const messages = {
    "en": {
        poMasterAdd:"Purchase Order Create",
        asnMasterAdd:"ASN Order Create",
        vendorMasterAdd:"Create Vendor",
        vendorMasterEdit:"Update Vendor",
        poMasterEdit:"Purchase Order Edit",
        txtPermissionRole:"Permission Master Role",
        txtPermissionRoleFilter:"Filter By Permission Master Role",
        txtPermission:"Permission Master",
        txtRoles:"Roles Master",
        txtMessages:"Message",
        txtSubject:"Subject",
        pageContactUs:"Contact Us Page",
        txtContactUs:"Contact Us",
        MainTxt:"Main",
        SupportTxt:"Support",
        skuMasterAdd:"Create Master SKU",
        CreateTxt:"Create",
        UpdateTxt:"Update",
        ReadTxt:"Read",
        DeleteTxt:"Delete",
        UploadTxt:"Upload Data",
        YesTxt:"Yes",
        NoTxt:"No",
        OnTxt:"ON",
        OffTxt:"OFF",
        DashboardMonitoringTxt:"Dashboard Monitoring",
        TripAlertTxt:"Trip Alert",
        GateAlertTxt:"Gate Alert",
        DocAlertTxt:"Doc Alert",
        ServiceAlertTxt:"Service Alert",
        OntimeAnalysisTxt:"Ontime Analysis",
        AdministrationTxt:"Administration",
        PermissionTxt:"Permission",
        PermissionAdd:"Add Permission",
        PermissionEdit:"Edit Permission",
        PermissionAddRole:"Add Permission Role",
        PermissionEditRole:"Edit Permission Role",
        loadingTxt:"Loading",
        submitFormTxt:"Submit Form",
        submitOrderTxt:"Save Order",
        resetFormTxt:"Reset Form",
        ChangePasswordTxt:"Change Password Page",
        changePassword:"Change Password",
        profileTxt:"User Profile Page",
        dashboardTxt : "Welcome to Linc Middleware",
        dashboardMenu : "Dashboard",
        autorizedErrorTxt : "Oopps!! The page not autorized for you",
        pageErrorTxt : "Oopps!! The page you were looking for doesn't exist",
        serverErrorTxt : "Oopps!! There wan an error. Please try agin later",
        companyCodeTxt : "Company Code", 
        companyCodeFilterTxt:"Filter By Company Code",
        companyTxt : "Company", 
        companyOmsTxt : "Company", 
        companyFulfillmentOmsTxt:"Company Fulfillment", 
        fulfillmentOmsTxt : "Fulfillment", 
        regionTxt : "Region", 
        usernameTxt : "Username",
        username_filter_Txt:"Filter By Username",
        emailAddress : "Email Address",
        emailAddressFilter:"Filter By Email Address",
        descriptionTxt : "Description",
        descriptionTxtFilter : "Filter By Description",
        roleNameTxt : "Role Name",
        roleNameTxtFilter : "Filter By Role Name",
        commodityCodeTxt : "Commodity Code",
        transactionData:"Transaction",
        permissionNameTxt : "Permission Name",
        permissionNameFilterTxt:"Filter By Permission Name",
        txtMyProfile:"Profile",
        txtUserSetting:"User Setting",
        txtUsers:"Users",
        detail_user_oms:"Detail User OMS",
        txtLanguage:"Language",
        txtSignOut:"Sign Out",
        txtNotification:"Notification",
        txtLogin:"Login",
        txtLogin2:"Please sign in to continue",
        pageForgotPassword:"Forgot Password Page",
        pageResetPassword:"Reset Password Page",
        nameTxt : "Name",
        name_filter_Txt : "Filter By Name",
        roleTxt : "Role",
        role_filter_Txt:"Filter By Role",
        companyAccessAdd:"Add Company",
        companyOmsAccessAdd:"Add Company OMS",
        companyFulfillmentOmsAccessAdd:"Add Company Fulfillment OMS",
        userOmsAccessAdd:"Add User OMS",
        userOmsAccessEdit:"Edit User OMS",
        fulfillmentOmsAccessAdd:"Add Fulfillment OMS",
        companyAccessEdit:"Edit Company",
        companyOmsAccessEdit:"Edit Company OMS",
        companyFulfillmentOmsAccessEdit:"Edit Company Fulfillment OMS",
        fulfillmentOmsAccessEdit:"Edit Warehouse OMS",
        regionAccessAdd:"Add Region",
        regionAccessEdit:"Edit Region",
        packageAccessAdd:"Add Package",
        packageAccessEdit:"Edit Package",
        postalCodeAccessAdd:"Add Postal Code",
        postalCodeAccessEdit:"Edit Postal Code",
        fulfillmentCode:"Fulfillment Code",
        companyCode:"Company Code",
        companyCodeFilter:"Filter By Company Code",
        companyName:"Company Name",
        fulfillmentName:"Fulfillment Name",
        companyCountry:"Country",
        companyProvince:"Province",
        companyCity:"City",
        companyArea:"Area",
        companySubArea:"Sub Area",
        companyVillage:"Village",
        companyAddress:"Address",
        address:"Address",
        companyPostalCode:"Postal Code",
        companyCodeChoose:"Choose Company Code",
        regionCode:"Region Code",
        packageCode:"Package Code",
        packageName:"Package Name",
        countryTxt:"Country",
        countryCodeTxt:"Country Code",
        provinceTxt:"Province",
        cityTxt:"City",
        masterData:"Master Data",
        cityTypeTxt:"City Type",
        districtTxt:"District",
        subDistrictTxt:"Sub District",
        postalCodeTxt:"Postal Code",
        password:"Password",
        newPassword:"New Password",
        passwordConfirm:"Password Confirmation",
        forgotPassword:"Forgot Password",
        rememberPassword:"Remember Password",
        resetPassword:"Reset Password",
        captchaCode:"Captcha Code",
        dashboard:"Dashboard",
        areYouSure:"Are you sure ?",
        yourData: "Submit data.",
        yourDataApprove: "You want to approve data ",
        yourDataDelete: "You want to delete data",
        yourDataSend:"You want to send selected data",
        yourDataCancel:"You want to cancel selected data",
        settings: "Settings",
        wrongCaptchaCode:"wrong Captcha Code",
        mainMenu:"Main Menu",
        page404Desc:"we couldn't find the page you are looking for",
        page500Desc:"Our server is experiencing problems, please try again in a few moments.",
        goHOmeDesc:"Go Home",
        userSettings:"User Settings",
        commodityTxt:"Commodity",
        locationTxt:"Location",
        locationCodeTxt:"Location Code",
        locationAdd:"Add Location",
        locationNameTxt:"Location Name",
        locationEdit:"Edit Location",
        locationContactName:"Contact Name",
        locationPhoneNumber:"Phone Number",
        systemCodeTxt:"System Code",
        systemCodeAdd:"Add System Code",
        systemCodeEdit:"Edit System Code",
        skuCodeTxt:"SKU",
        skuDescriptionTxt:"SKU Description",
        skuLongDescriptionTxt:"SKU Long Description",
        skuAdd:"Add SKU",
        skuEdit:"Edit SKU",
        name:"Name",
        stopLocationTxt : "Stop Location",
        stopLocationAccessAdd:"Add Stop Location",
        stopLocationAccessEdit:"Edit Stop Location",
        driverTxt : "Driver",
        driverAccessAdd:"Add Driver",
        driverAccessEdit:"Edit Driver",
        driver_id:"Driver ID",
        driver_name:"Driver Name",
        branch_id:"Branch ID",
        site_name:"Site Name",
        project_name:"Project Name",
        driver_position:"Driver Position",
        hp1:"HP 1",
        hp2:"HP 2",
        wa_hp1:"WA HP 1",
        sap_code:"SAP Code",
        sap_code_filter:"Filter By SAP Code",
        driver_status:"Driver Status",
        status_remark:"Status Remark",
        join_date:"Join Date",
        nickname:"Nickname",
        brith_place:"Birth Place",
        brith_date:"Birth Date",
        sim_type:"SIM Type",
        sim_expire_date:"SIM Expire Date",
        ethnic:"Ethnic",
        status_filter_txt:"Filter By Status",
        truckTxt : "Truck",
        truckAccessAdd:"Add Truck",
        truckAccessEdit:"Edit Truck",
        typeDocumentTxt : "Type Document",
        typeDocumentAccessAdd:"Add Type Document",
        typeDocumentAccessEdit:"Edit Type Document",
        documentTxt : "Document",
        documentAccessAdd:"Add Document",
        documentAccessEdit:"Edit Document",
        statusTxt : "Status",
        statusAccessAdd:"Add Status",
        statusAccessEdit:"Edit Status",
        branchTxt : "Branch",
        branchAccessAdd:"Add Branch",
        branchAccessEdit:"Edit Branch",
        branchAccessDetail:"Detail Branch",
        branch_name:"Branch Name",
        branch_province:"Branch Provinsi",
        branch_city:"Branch City",
        branch_region:"Branch Region",
        branch_address:"Branch Address",
        branch_latitude:"Branch Latitude",
        ac_category: "AC Category",
        box_category: "Box Category",
        vehicle_no: "Vehicle No",
        carrier: "Carrier",
        device_id:"Device ID",
        engine_number: "Engine No",
        gps_vendor: "GPS Vendor",
        km_limit: "KM Limit",
        manufacture_year: "Manufacture Year",
        name_of_owner: "Name of Owner",
        ownership: "Ownership",
        project: "Project",
        purchased_year: "Purchase Year",
        remark: "Remark",
        truck_brand: "Truck Brand",
        truck_model: "Truck Model",
        truck_status: "Truck Status",
        type_truck: "Type Truk",
        unit_allocation: "Unit Alocation",
        last_service:"Last Service",
        last_km_service:"Last KM Service",
        vin: "Vin",
        division:"Division",
        divisionCode:"Division Code",
        divisionDesc:"Division Description",
        wrongPasswordConfirm:"Password confirmation does not match",
        userAccess:"User Access",
        userAccessList:"List User Access",
        userAccessDetail:"Detail User Access",
        userAccessEdit:"Edit User Access",
        packageTxt:"Package",
        backMess:"Back",
        editMess:"Edit",
        deleteMess:"Delete",
        submitMess:"Submit",
        createNew:"Create New Data",
        downloadData:"Download Data",
        uploadData:"Upload Data",
        userAccessAdd:"Add New User Access",
        roleAdd:"Add Role",
        roleEdit:"Edit Role",
        sequenceTxt : "Sequence",
        valueTxt : "Value",
        commodityAdd:"Add Commodity",
        commodityEdit:"Edit Commodity",
        FakturPajakTxt:"Tax Invoice",
        FakturPajakAdd: "Add Tax Invoice",
        FakturPajakDetail: "Detail Tax Invoice",
        FakturPajakEdit: "Edit Tax Invoice",
        images_txt:"Images",
        customerTxt:"Master Customer",
        customerAddTxt:"Create New Customer",
        location_reference_number_txt:"Location Reference Number",
        stateTxt:"State",
        customerDetailTxt:"Detail Customer",
        customerEditTxt:"Edit Customer",
        coulmn_issue_txt:"Column Issue",
        description_txt:"Description Issue",
        company_type_txt:"Company Type",
        user_type_txt:"User Type",
        user_type_filter_txt:"Filter By User Type",
        date_range_txt:"Date Range",
        search_txt:"Search",
        check_internet_connection_txt:"Please Check Your Internet Connection",
        day_order_history_txt:"Days Order History",
        year_order_history_txt:"12 Months Order History",
        day_truck_order_history_txt:"Days Truck Type  Order History",
        year_truck_order_history_txt:"12 Months Truck Type Order History",
        no_data_available_txt:"No Data Available",
        day_30_order_history_txt:"30 Days Order History",
        day_30_truck_order_history_txt:"30 Days Truck Type Order History",
        transport_orders_txt:"Transport Order",
        transport_txt:"Transport",
        orders_txt:"Orders",
        order_no_txt:"Order No",
        order_date_txt:"Order Date",
        order_status_txt:"Order Status",
        send_order_txt:"Submit Order",
        cancel_order_txt:"Cancel Order",
        draft_order_txt:"Draft Order",
        pick_name_txt:"Pick Name",
        dest_name_txt:"Dest Name",
        action_txt:"Action",
        submit_time_txt:"Submit Time",
        transport_order_template_description_txt:"Order Template Name",
        tonnage_txt:"Tonnage",
        cubic_txt:"Cubic",
        pickup_plan_txt:"Pickup Plan",
        dest_plan_txt:"Dest Plan",
        accept_order_txt:"Accept Order",
        reject_order_txt:"Reject Order",
        postpone_order_txt:"Postpone Order",
        postpone_time_txt:"Postpone Time",
        hide_map_txt:"Hide Map",
        show_map_txt:"Show Map",
        tracking_status_txt:"Tracking Status",
        audit_info_txt:"Audit Info",
        detail_transport_order_txt:"Detail Transport Order",
        edit_transport_order_txt:"Edit Transport Order",
        create_by_txt:"Created By",
        create_at_txt:"Created At",
        update_by_txt:"Updated By",
        update_at_txt:"Updated At",
        integration_status_txt:"Integration Status",
        integration_description_txt:"Integration Description",
        load_id_txt:"Load ID",
        tms_id_txt:"TMS ID",
        status_tms_txt:"TMS Status",
        template_order_txt:"Template Order",
        remarks_txt:"Remarks",
        shipwith_ref_txt:"Shipwith ref",
        pickup_txt:"Pickup",
        pickup_location_txt:"Pickup Location",
        latitude_txt:"Latitude",
        longitude_txt:"Longitude",
        destination_txt:"Destination",
        destination_location_txt:"Destination Location",
        destination_plan_txt:"Destination Plan",
        maps_txt:"Maps",
        detail_txt:"Detail",
        sku_txt:"SKU",
        sku_description_txt:"SKU Description",
        qty_txt:"Qty Charge",
        package_type_txt:"Package Type",
        lading_type_txt:"Lading Type",
        lading_length_txt:"Lading Length",
        lading_width_txt:"Lading Width",
        lading_height_txt:"Lading Height",
        volume_txt:"Volume",
        weight_txt:"Weight",
        net_weight_txt:"Net Weight",
        lading_qty_txt:"Lading Qty",
        close_txt:"Close",
        ct_operation_performance_txt:"CT Operator Performance",
        reject_time_txt:"Reject Time",
        total_hours_txt:"Total Hours",
        edit_order_txt:"Edit Order",
        reason_txt:"Reason",
        reason_category_txt:"Reason",
        save_change_txt:"Save Change",
        reject_category_txt:"Reject Category",
        reject_description_txt:"Reject Description",
        type_reject_description_txt:"Type Description",
        pools_count_txt:"Pool Total",
        branch_address_txt:"Branch Address",
        branch_region_txt:"Branch Region",
        branch_city_txt:"Branch City",
        branch_province_txt:"Branch Province",
        branch_name_txt:"Branch Name",
        branch_longitude:"Branch Longitude",
        branch_poscode:"Branch Postalcode",
        pool_name:"Pool Name",
        pool_province:"Pool Province",
        pool_city:"Pool City",
        pool_postalcode:"Pool Postal Code",
        pool_latitude:"Pool Latitude",
        pool_longitude:"Pool Longitude",
        pool_address:"Pool Address",
        pool_txt:"Pool",
        txtUserMapping:"User Mapping",
        txtUserMappingCreate:"Create User Mapping",
        txtUserMappingDetail:"Detail User Mapping",
        user_choose_txt:"Choose User",
        pool_choose_txt:"Choose Pool",
        audit_info:"Audit  Info",
        id_pemotong:"ID Pemotong",
        name_pemotong:"Nama Pemotong",
        id_dipotong:"ID Dipotong",
        nama_dipotong:"Nama Dipotong",
        pasal:"Pasal",
        kode_objek_pajak:"Kode Objek Pajak",
        no_bukti_potong:"No Bukti Potong",
        tgl_bukti_potong:"Tgl Bukti Potong",
        pph_dipotong:"PPH Dipotong",
        jumlah_bruto:"Jumlah Bruto",
        keterangan:"Keterangan",
        file:"File",
        download_file:"Download File",
        branch_phone:"Branch Phone",
        branch_phone2:"Branch Phone 2",
        parking:"Parking",
        kir:"KIR",
        corrective_maintenance:"Corrective Maintenance",
        preventive_maintenance:"Preventive Maintenance",
        truck_type:"Truck Type",
        date:"Date",
        time:"Time",
        permit_status:"Permit Status",
        truck_record_by_permit_status:"Truck Record By Permit Status",
        truck_record_by_permit:"Truck Record By Permit",
        more_record:"More Records",
        truck_record_by_type:"Truck Record By Type",
        period_from:"Period From",
        period_to:"Period To",
        period:"Period",
        sampai:"To",
        result_txt:"Result",
        in_out_txt:"In / Out",
        from:"From",
        all:"All",
        pool_location:"Pool Location",
        yes_txt:"Yes",
        no_txt:"No",
        transaction_date:"Transaction Date",
        needs:"Needs",
        km:"KM",
        muatan:"Cargo",
        stnk:"STNK",
        ktp:"KTP",
        clear:"Clear",
        load_id:"Load ID",
        load_group:"Load Group",
        last_order:"Last Order",
        handphone:"Handphone",
        sim:"SIM",
        surveyor:"Surveyor",
        km_gps:"KM Gps",
        km_real:"KM Real",
        km_service:"KM Service",
        status_remarks:"Status Remarks",
        in_to_pool:"In To Pool",
        exit_from_pool:"Exit From Pool",
        nomor:"No",
        shipment_number:"Shipment Number",
        customer:"Customer",
        route:"Route",
        equipment:"Equipment",
        dongkrak:"Dongkrak",
        spion_kanan:"Spion Kanan",
        spion_kiri:"Spion Kiri",
        ban_stip:"Ban Stip",
        kotak_p3k:"Kotak P3K",
        ban_serep:"Ban Serep",
        radio_tape:"Radio Tape",
        speedometer:"Speedometer",
        pick_some_type_truck:"Pick Some Type Truck",
        truck_selected:"Truck Selected",
        kunci_roda:"Kunci Roda",
        pick_some_pool_name:"Pick Some Pool Name",
        branch_selected:"Branch Selected",
        data_selected:"Data selected",
        news_portal_txt:"News Portal",
        news_portal_create_txt:"Create News Portal",
        news_from_date:"Date News From",
        news_to_date:"Date News To",
        title:"Title",
        brief:"Brief",
        active_txt:"Active",
        deactive_txt:"Deactive",
        news_detail:"News Detail",
        drop_and_drop_file:"Drag and drop or click to replace",
        something_wrong:"something wrong appended",
        remove_txt:"Remove",
        no_select_data: "There is no selected row ",
        news_portal_detail_txt:"Detail News Portal",
        news_portal_edit_txt:"Edit News Portal",
        companyGroupTxt:"Company Group",
        companyGroupBillingTxt:"Billing Company Group",
        company_group_code_txt:"Company Group Code",
        company_group_code_filter_txt:"Filter By Company Group Code",
        company_group_description_txt:"Company Group Description",
        company_group_description_filter_txt:"Filter By Company Group Description",
        create_company_group_txt:"Create Company Group",
        customer_code:"Customer Code",
        customer_code_filter:"Filter By Customer Code",
        customer_description:"Customer Description",
        customer_description_filter:"Filter By Customer Description",
        company_group_id:"Company Group ID",
        billing_customer_c01:"Addtional Form 1",
        billing_customer_c02:"Addtional Form 2",
        billing_customer_c03:"Addtional Form 3",
        billing_customer_c04:"Addtional Form 4",
        billing_customer_c05:"Addtional Form 5",
        billing_customer_c06:"Addtional Form 6",
        billing_customer_c07:"Addtional Form 7",
        billing_customer_c08:"Addtional Form 8",
        billing_customer_c09:"Addtional Form 9",
        billing_customer_c10:"Addtional Form 10",
        customer_detail:"Detail Customer",
        customer_edit:"Edit Customer",
        fulfillment:"Warehouse",
        fulfillment_name:"Warehouse Name",
        fulfillment_code:"Warehouse ID",
        fulfillment_code_filter:"Filter By Warehouse Code",
        fulfillment_description:"Warehouse Description",
        fulfillment_center_id:"ID Warehouse",
        fulfillment_description_filter:"Filter By Warehouse Description",
        fulfillmentAddTxt:"Create New Warehouse",
        area_palet:"Area Pallet",
        mover_area:"Mover Area",
        total_area:"Total Area",
        pallet_size:"Pallet Size",
        luas_area_pallet:"Pallet Area plain",
        stacking:"Stacking",
        max_pallet:"Max Pallet",
        fulfillment_detail:"Warehouse Detail",
        fulfillment_edit:"Warehouse Edit",
        billing:"Billing",
        warehouse_system_code:"Warehouse System Code",
        category:"Category",
        category_filter:"Filter By Category",
        code_type:"Code Type",
        code_type_filter:"Filter By Code Type",
        code_description:"Code Description",
        code_description_filter:"Filter By Code Description",
        return_issue:"Return Issue",
        field_issue:"Field Issue",
        response_issue:"Response Issue",
        warehouse_system_code_detail:"Warehouse System Code Detail",
        code_id:"Code ID",
        outer_code:"Outer Code",
        show_sequence:"Show Sequence",
        active_flag:"Active Flag",
        default_flag:"Default Flag",
        udf01:"udf01",
        udf02:"udf02",
        udf03:"udf03",
        udf04:"udf04",
        udf05:"udf05",
        wsc01:"wsc01",
        wsc02:"wsc02",
        wsc03:"wsc03",
        wsc04:"wsc04",
        wsc05:"wsc05",
        wsc06:"wsc06",
        wsc07:"wsc07",
        wsc08:"wsc08",
        wsc09:"wsc09",
        wsc10:"wsc10",
        warehouse_system_code_create:"Create Warehouse System Code",
        customer_id:"Customer ID",
        warehouse_system_code_edit:"Edit Warehouse System Code",
        system_code_edit:"Edit System Code",
        BmCodelkupTxt:"BM Code",
        categoryCode_txt:"Category Code",
        categoryCode_filter_txt:"Filter By Category Code",
        chargeType_txt:"Charge Type",
        chargeType_filter_txt:"Filter By Charge Type",
        materialCode_txt:"Material Code",
        materialCode_filter_txt:"Filter By Material Code",
        rateBase_txt:"Rate Base",
        rateBaseName_txt:"Ratebase Name",
        rateBaseDesc_txt:"Rate Base Description",
        rateBase_filter_txt:"Filter By Rate Base",
        rateBaseDetail:"Rate Base Detail",
        ratebaseAdd:"Create Ratebase",
        ratebaseEdit:"Edit Ratebase",
        create_customer_txt:"Create Customer",
        create_bm_code_txt:"Create BM Code",
        update_bm_code_txt:"Update BM Code",
        detail_bm_code_txt:"Detail BM Code",
        cli_txt:"CLI",
        cml_txt:"CML",
        rate_txt:"Rate",
        billing_txt:"Billing",
        cli_rate:"CLI Rate",
        rateName_txt:"Rate Name",
        rateName_filter_txt:"Filter By Rate Name",
        warehouseId_txt:"Warehouse ID",
        warehouseId_filter_txt:"Filter By Warehouse ID",
        customerId:"Customer ID",
        customerId_filter:"Filter By Customer ID",
        customerGroup:"Customer Group",
        customerGroup_filter:"Filter By Customer Group",
        customerSAPCode:"Customer SAP Code",
        customerSAPCode_filter:"Filter By Customer SAP Code",
        firstBilingDate:"First Blling Date",
        firstBilingDate_filter:"Filter By First Blling Date",
        effectiveFromDate:"Effective From Date",
        effectiveFromDate_filter:"Filter By Effective From Date",
        effectiveToDate:"Effective To Date",
        effectiveToDate_filter:"Filter By Effective To Date",
        CliMasterWarehouseTxt:"CLI Master Warehouse",
        CmlMasterWarehouseTxt:"CML Warehouse",
        MasterWarehouseTxt:"Warehouse",
        warehouseDescr_txt:"Warehouse Description",
        warehouseDescr_filter_txt:"Filter By Warehouse Description",
        activeFlag_txt:"Active Flag",
        activeFlag_filter_txt:"Filter By Active Flag",
        MasterCustomerTxt:"Customer",
        CliMasterCustomerTxt:"CLI Master Customer",
        CmlMasterCustomerTxt:"CML Customer",
        customerId_txt:"Customer ID",
        customerId_filter_txt:"Filter By Customer ID",
        customerName_txt:"Customer Name",
        customerName_filter_txt:"Filter By Customer Name",
        rate_create:"Create Billing Rate",
        effectiveDate_txt:"Effective Date",
        transactionDate_txt:"Transaction Date",
        firstBilingDate_txt:"First Billing Date",
        applyTxt:"Apply",
        chargeCategory_txt:"Charge Category",
        chargeCategory_filter_txt:"Filter By Charge Category",
        SAPMaterialCode:"SAP Material Code",
        SAPMaterialCode_filter:"Filter By SAP Material Code",
        SAPDivision:"SAP Division",
        SAPDivision_filter:"Filter By SAP Division",
        tier:"Tier",
        tier_filter:"Filter By Tier",
        tierQty:"Tier QTY",
        tierQty_filter:"Filter By Tier QTY",
        ratePerUnit:"Rate Per Unit",
        ratePerUnit_filter:"Filter By Rate Per Unit",
        remark_filter:"Filter By Remarks",
        addDetail:"Add Detail",
        create_rate_detail_txt:"Create Rete Detail",
        detail_rate_detail_txt:"Detail Rete Detail",
        addwho:"Created By",
        adddate:"Created At",
        editwho:"Updated By",
        editdate:"Updated At",
        dashboardBillingTxt:"Dashboard Billing",
        edit_rate_detail_txt:"Edit Rate Detail",
        edit_rate_header_txt:"Edit Rate Header",
        cli_billing:"CLI Billing",
        amount_txt:"Amount",
        edit_billing_header_txt:"Edit Billing Header",
        rate_detail_txt:"Rate Detail",
        billing_detail_txt:"Billing Detail",
        billing_summary_detail_txt:"Detail Billing Summary Category",
        upload_vas:"Upload Vas",
        upload_Overtime:"Upload Overtime",
        download_template_vas:"Download Template VAS",
        upload_overtime:"Upload Overtime",
        download_template_overtime:"Download Template Overtime",
        billingId:"Billing ID",
        billing_category_detail_txt:"Billing Category",
        amountCategory:"Amount Category",
        billing_sub_detail_txt:"Sub Detail",
        docNo:"Doc No",
        docNo_filter:"Filter By Doc No",
        docLineNo:"Doc Line No",
        receiveDate:"Receive Date",
        docType:"Doc Type",
        uom:"Uom",
        changeStatus:"Change Status",
        nik:"NIK",
        startOvertime:"Start Overtime",
        endOvertime:"End Overtime",
        breakTime:"Break Time",
        totalOvertime:"Total Overtime",
        locationCategory:"Location Category",
        stockDate:"Stock Date",
        shipmentDate:"Shipment Date",
        unselect_data_txt:"Unselect Data",
        query:"Query",
        recalculate:"Recalculate",
        confirmed:"Confirmed",
        clearCalender:"Clear Calendar",
        inSelection:"In Selection",
        uploadDataOvertime:"Upload Data Overtime",
        uploadDataVAS:"Upload Data VAS",
        vasType:"VAS Type",
        form_download_data:"Form Download  Data",
        omsNumber:"OMS Number",
        airwayBill:"Air wayBill",
        asnReference1:"ASN Reference 1",
        skuGroup:"SKU Group",
        historyData:"History Data",
        link_download:"Link Download",
        storageType:"Storage Type",
        cbm:"CBM",
        qty_charge:"QTY Charge",
        qty_each:"QTY Each",
        qty_cases:"QTY Cases",
        salesGroup:"Sales Group",
        salesOffice:"Sales Office",
        udf01Aag:"AAG",
        udf02SAPCode:"SAP CODE",
        downloadXml:"Download XML",
        history_sync:"History Sync",
        tariffId:"Tarif ID",
        rateDesc:"Rate Description",
        cml_rate:"CML Rate",
        organizationId:"Organization Id",
        tarifMasterTxt:"Tariff Master",
        tarifMasterId:"Tariff Master Wms",
        tarifMasterAdd:"Create Tariff Master",
        tarifMasterDetail:"Detail Tariff Master",
        tarifMasteEdit:"Edit Tariff Master",
        masterLocations:"Location",
        zona:"Zone",
        idRateHeader:"ID Rate",
        detailHandling:"Detail Handling",
        detailStorage:"Detail Storage",
        rate_detail_handling:"Rate Detail Handling",
        create_rate_detail_handling:"Create Rate Detail Handling",
        detail_rate_detail_handling:"Detail Rate Detail Handling",
        update_rate_detail_handling:"Edit Rate Detail Handling",
        rate_detail_storage:"Sub Detail Rate Storage",
        create_rate_detail_storage:"Create Sub Detail Rate Storage",
        detail_rate_detail_storage:"Detail Sub Detail Rate Storage",
        update_rate_detail_storage:"Update Sub Detail Rate Storage",
        rate_detail_substorage:"Sub Detail Rate Storage",
        create_rate_detail_substorage:"Create Sub Detail Rate Storage",
        detail_rate_detail_substorage:"Detail Sub Detail Rate Storage",
        update_rate_detail_substorage:"Update Sub Detail Rate Storage",
        transactionFromDate:"Transaction From Date",
        transactionToDate:"Transaction To Date",
        cml_billing : "CML Billing",
        cml_billing_detail : "CML Billing Detail",
        cml_billing_create : "Create Billing CML",
        cml_billing_edit : "Edit Billing CML",
        idBillingHeader:"ID Billing",
        pleaseSelectCompanyAndWarehouse : "Please select Company and warehouse first",
        whatsapp:"Whatsapp",
        master_phone_number_id:"Master Phone Number ID",
        qr:"QR",
        waBrowserId:"WA Browser Id",
        waSecretBundle:"WA Secret Bundle",
        waToken1:"WA Token 1",
        waToken2:"WA Token 2",
        master_phone_number:"Master Phone Number",
        phone_number:"Phone Number",
        phone_name:"Phone Name",
        master_phone_create:"Create Master Phone",
        detail_master_phone_number:"Detail Master Phone Number",
        edit_master_phone_number:"Edit Master Phone Number",
        waStatus:"WA Status",
        message_data:"Message Data",
        idBillingDetail:"Id Billing Detail",
        qtyCharge:"Qty Charge",
        rate:"Rate",
        idDetailStorage:"ID Detail Storage",
        zone:"Zone",
        keyLocation:"Key Location",
        idSubDetailStorage:"ID Sub Detail Storage",
        traceId:"Trace ID",
        locationId:"Location ID",
        MUID:"MUID",
        qtyOnHand:"Qty On Hand",
        qtyOnCases:"Qty On Case",
        qtyPallet:"Qty Pallet",
        cube:"Cube",
        totalCube:"Total Cube",
        cml_billing_detail_storage:"CML Billing Detail Storage",
        idDetailHandlingIn:"ID Detail HI",
        poReference:"PO Reference",
        batch:"Batch",
        qtyEA:"Qty Each",
        qtyCase:"Qty Case",
        soReference:"SO Reference",
        totalArea:"Total Area",
        totalPallet:"Total Pallet",
        cml_billing_detail_handling_in:"CML Billing Detail Handling In",
        cml_billing_detail_handling_out:"CML Billing Detail Handling Out",
        idDetailHandlingOut:"ID Detail HO",
        cml_billing_detail_handling_storage:"ID Detail Handling Storage",
        cml_billing_detail_handling_storage_sub:"ID Detail Handling Sub Storage",
        idDetail_Overtime:"ID Detail Overtime",
        transactionType:"Transaction Type",
        position:"Position",
        hourOvertime:"Hour Overtime",
        cml_billing_detail_handling_overtime:"CML Billing Detail Handling Overtime",
        sbu_sku:"SBU SKU",
        overtimeType:"Overtime Type",
        total_amount:"Total Amount",
        download_template_extra_handling:"Download Template Extra Handling",
        idDetail_ExtraHandling:"ID Detail EH",
        basicSalary:"Basic Salary",
        salary:"Salary",
        uploadDataExtraHandling:"Upload Data Extra Handling",
        upload_extra_handling:"Upload Extra Handling",
        tunjangan:"Tunjangan",
        adjustmentUp:"Adjustment Up",
        adjustmentDown:"Adjustment Down",
        subTotal:"Sub Total",
        bpjsTk:"BPJS Tk",
        bpjsKes:"BPJS Kes",
        jaminanPensiun:"Jaminan Pensiun",
        totalKotor:"Total Kotor",
        rateManagement:"Rate Management",
        amountManagement:"Amount Management",
        ppH:"PPH",
        amountPph:"Amount PPH",
        ppn:"PPN",
        amountPpn:"Amount PPN",
        grandTotal:"Grand Total",
        cml_billing_detail_handling_extra_handling:"CML Billing Detail Handling Extra Handling",
        rateOt:"Rate OT",
        amountOt:"Amount OT",
        totalWorkDay:"Total WorkDay",
        minQty:"Min Qty",
        minAmount:"Min Amount",
        id_whatsapp_msg:"ID WA MSG",
        from_phone_number:"From Phone Number",
        type:"Type",
        code:"Code",
        wa_master_phone_number:"WA Master Phone Number",
        wa_message_data:"WA Message Data",
        wa_message_create:"Create WA Message",
        wa_message_detail:"Detail WA Message",
        wa_message_update:"Update WA Message",
        app_form:"APP From",
        message:"Message",
        attachment:"Attachment",
        sid:"SID",
        download_attachment:"Download Attachment",
        idDetailVAS:"ID Detail VAS",
        cml_billing_detail_handling_vas:"CML Billing Detail VAS",
        totalHourOt:"Total Hour OT",
        detail:"Detail",
        idTarifMasterHeader:"ID Tariff",
        idDetailRentalPallet:"ID Detail RP",
        cml_billing_detail_rental_pallet:"CML Billing Detail Rental Pallet",
        idDetailMinimumCharge:"ID Detail Minimum Charge",
        cml_billing_detail_minimum_charge:"CML Billing Detail Minimum Charge",
        storage_estimation:"Storage Estimation",
        idEstimation:"ID Estimation",
        trxDate:"Transaction Date",
        wms_code:"WMS Code",
        idWmsCode:"ID WMS Code",
        codeType:"Code Type",
        codeId:"Code ID",
        codeDesc:"Code Description",
        showSeq:"Show Sequence",
        outerCode:"Outer Code",
        defaultFlag:"Default Flag",
        detail_wms_code:"Detail WMS Code",
        locCategory:"Location Category",
        locCategoryCode:"Location Category Code",
        itemCategory:"Item Category",
        upload_billing_list:"Upload Billing List",
        form_upload_data:"Form Upload Data",
        please_choose_one:"Please Choose One",
        maxQty:"Max Qty",
        cml_billing_detail_summary_handling_charge:"CML Billing Detail Summary Handling",
        cml_billing_detail_summary_storage:"CML Billing Detail Summary Storage Multi Warehouse",
        cml_billing_detail_summary_storage_muid:"CML Billing Detail Summary Storage MUID",
        cml_billing_detail_summary_storage_pltused:"CML Billing Detail Summary Storage Pallet Used",
        idSummaryHandling:"ID Summary Handling",
        referenceNo:"Reference No",
        blujay:"Blujay",
        chain:"Chain",
        id:"ID",
        filename:"File Name",
        created_at:"Created At",
        success:"Success",
        error:"Error",
        reset_filter_txt:"Reset Filter",
        clear_calender:"Clear Calender",
        in_selection:"In Selection",
        datas:"Datas",
        datas_structure:"Datas Structure",
        datas_response:"Datas Response",
        datas_xml:"Datas XML",
        datas_structure_xml:"Datas Structure XML",
        datas_response_xml:"Datas Response XML",
        multi_warehouse_flag:"Multi Warehouse",
        summaryFlag:"Summary ",
        idSummaryStorage:"ID Sum Storage",
        idSummaryStorageMuid:"ID Summary Storage Muid",
        sumQtyOnhand:"Sum Qty OnHand",
        sumPalletUsed:"Sum Qty Pallet Used",
        sumCBM:"Sum CBM",
        sumQtyCharge:"Sum Qty Charge Multi Warehouse",
        amount:"Amount",
        status:"Status",
        interfaceStatus:"Interface Status",
        minQtyFlag:"Min Qty",
        idSumStrgPltUsed:"ID Plt Used",
        recalculateByDate:"Recalculate By Date",
        recalculateAmount:"Recalculate Amount",
        logic_info:"Logic Info",
        sumPalletUsedSkuBatch:"Sum Qty Pallet Used Sku Batch",
        qtyEach:"Qty Each",
        qtyPerPallet:"Qty Per Pallet",
        qtyPerCase:"Qty Per Case",
        sumCbmMultiWh:"Sum CBM Multi Warehouse",
        uploadDataSAP:"Upload Data SAP",
        downloadTemplateDataSAP:"Download Template Data SAP",
        no:"No",
        messageTxt:"Message",
        uploadDataAdditionalWMS:"Upload Data Additional WMS",
        downloadTemplateDataAdditionalWMS:"Download Template Data Additional WMS",
        dataSAP:"Data SAP",
        titleCmlDetailDataSAP:"CML Detail Data SAP",
        idDetailCust:"ID Detail Cust",
        idMatch:"ID Match",
        materialNo:"Material No",
        plantCode:"Plant Code",
        storageLocation:"Storage Location",
        movementType:"Movement Type",
        materialDoc:"Material Doc",
        postDate:"Post Date",
        qtyUnit:"Qty Unit",
        materialDesc:"Material Description",
        docHeader:"Doc Header",
        purchaseOrder:"Purchase Order",
        debitOrCredit:"Debit Or Credit",
        userName:"Username",
        reference:"Reference",
        dataMatchingProcess:"Match Data",
        additionalFlag:"Data Additional",
        plant:"Plant",
        sloc:"Sloc",
        key1:"Key",
        DataCustSapTotalRowsCount:"Total Rows Data SAP",
        DataCustSapMatchCount:"Total Rows Match",
        DataCustSapUnmatchCount:"Total Rows Unmatch",
        downloadDataWMS:"Download Data WMS",
        lineNo:"Line No",
        cmlDetailSubStorage:"CML Billing Detail Sub Storage",
        cmlDetailStorageByLocCat:"CML Billing Detail Storage By Location Category",
        cmlDetailSumStrgPltUsd:"CML Billing Detail Summary Storage Pallet Used",
        cmlDetailSumStrgMuid:"CML Billing Detail Summary Storage Pallet Used MUID",
        cml_location:"CML Location",
        cml_tariff_master:"CML Tariff Master",
        cml_rate_base:"CML Rate Base",
        cml_wms_code:"CML WMS Code",
        downloadDataList:"Download Data List",
        recalcMatchData:"Recalculate Amount + Match Data",
        DataCustSapTotalRowsCancelCount:"Total Rows Cancel",
        cml_billing_detail_handling_in_add:"CML Billing Detail Handling In Additional",
        cml_billing_detail_handling_out_add:"CML Billing Detail Handling Out Additional",
        cml_billing_detail_equipment_type_add:"CML Billing Detail Equipment Type Additional",
        cml_billing_detail_equipment_type:"CML Billing Detail Equipment Type",
        contract_no:"Contract No",
        opportunity_id:"Opportunity ID",
        arrNo:"Arrival No",
        idRateBase:"Id Rate Base",
        sales_force:"Sales Force",
        idRateSalesForce:"Id Rate SF",
        sales_force_opportunity:"Sales Force Opportunity Billing",
        opportunity:"Opportunity",
        billing_opportunity:"Opportunity Billing",
        sales_force_opportunity_detail:"Sales Force Opportunity Billing Detail",
        detail_opportunity:"Detail Opportunity",
        idRateDetailSalesForce:"Id Rate Detail SF",
        product_code:"Product Code",
        product_Desc:"Product Description",
        price:"Price",
        quantity:"Quantity",
        massUploadTariffMaster:"Mass Upload Data Tariff Master",
        downloadTemplateTariffMaster:"Download Template Tariff Master",
        idLog:"Id Log",
        trxTypeName:"Transaction Type Name",
        countRowEksternal:"Total Rows Get Data",
        countRowInternal:"Total Rows Insert Data",
        titleCmlDetailLogsSyncTrx:"CML Detail Logs Sync Trx",
        typeName:"Type Name",
        dataRate:"Data Rate",
        flux_oms:"Flux OMS",
        outbound:"Outbound (SO)",
        list:"List",
        soMasterAdd:"Create Shipment Order",
        soMasterEdit:"Update Master SKU",
        inbound_po:"Inbound (PO)",
        inbound_asn:"Inbound (ASN)",
        interface:"Interface",
        company_id:"Company ID",
        company_code:"Company Code",
        company_name:"Company Name",
        customer_fulfillment_id:"Company Fulfillment ID",
        userOmsTxt:"User Mapping",
        oms_user_customer_mapping_id:"OMS User Mapping ID",
        downloadTemplateMasterSKU:"Download Template Master Sku",
        userAccessCompany:"User Access Company",
        companyAccessFulfillment:"Company Access Fulfillment",
        dashboardLincMiddleware:"Dashboard Linc Middleware",
        lotAtt07:"Rental Pallet Type",
        cmlDetailSumStrgQty:"CML Billing Detail Summary Storage Qty",
        idSummaryStorageQty:"ID Sum Strg Qty",
        sumQty:"Sum Qty Charge",
        palletType:"Pallet Type",
        idMaster_Customer:"Id Master Customer",
        idMaster_Warehouse:"Id Master Warehouse",
        idLocCategory:"Id Location Category",
        totalRowInterfaces:"Data Interface",
        qtyBeginningBalance:"Storage Beg Bal",
        beginningBalanceFlag:"Storage Beginning Balance",
        queryBeginningBalance:"Query Storage Beginning Balance",
        blujayBcaMasterLocationTxt:"Master Location",
        blujayBcaUserMappingLocationTxt:"User Mapping Location",
        bca:"BCA",
        yourRemarks:"Your Remarks",
        ceisa:"CEISA DJBC",
        master_data:"Master Data",
        system_code:"System Code",
        system_code_detail:"Detail System Code",
        system_code_create:"Create System Code",
        system_code_upload:"Upload System Code",
        client_login:"Client Login",
        client_login_edit:"Edit Client Login",
        system_code_id:"System Code ID",
        client_id:"Client ID",
        endpoint:"Endpoint",
        create:"Create",
        dukumen_impor:"Import Document",
        pib:"PEMBERITAHUAN IMPOR BARANG (PIB)",
        jenis_pib:"Jenis PIB",
        header:"Header",
        detail_barang:"Detail Barang",
        entitas:"Entitas",
        kemasan:"Kemasan",
        kontainer:"Kontainer",
        dokumen:"Dokumen",
        pengangkut:"Pengangkut",
        kantor_pabean:"Kantor Pabean",
        nomor_pengajuan:"Nomor Pengajuan",
        jenis_impor:"Jenis Impor",
        cara_pembayaran:"Cara Pembayaran",
        ppjk_name:"PPJK Name",
        ppjk_id:"PPJK ID",
        create_client_login:"Create Client Login",
        ppjk:"PPJK",
        no_npwp:"NPWP No",
        np_ppjk:"PPJK No",
        ppjk_detail:"PPJK Detail",
        ppjk_edit:"PPJK Edit",
        ppjk_create:"PPJK Create",
        pengirim:"PENGIRIM",
        nama:"Nama",
        alamat:"Alamat",
        negara:"Negara",
        kode_negara:"Kode Negara",
        penjual:"PENJUAL",
        pemilik_barang:"PEMILIK BARANG",
        identitas:"Identitas",
        importir:"IMPORTIR",
        cara_pengangkutan:"Cara Pengangkutan",
        sarana_pengangkutan:"Sarana Pengangkutan",
        no_voy:"No. Voy/Flight",
        bendera:"Bendera",
        perkiraaan_tanggal_tiba:"Perkiraan Tangggal Tiba",
        pelabuhan_muat:"Pelabuhan Muat",
        pelabuhan_transit:"Pelabuhan Transit",
        pelabuhan_tujuan:"Pelabuhan Tujuan",
        invoice:"Invoice",
        transaksi:"Transaksi",
        house_bl_awb:"House-BL/AWB",
        master_bl_awb:"Master-BL/AWB",
        identity_number:"Identity Number",
        nib:"NIB",
        customer_upload:"Customer Upload",
        customer_type:"Customer Type",
        customer_create:"Customer Create",
        customer_update:"Customer Update",
        dokumen_pabean:"Dokumen Pabean",
        kodeDokumen:"Kode Dokumen",
        nomorAju:"Nomor Pengajuan",
        tanggalAju:"Tanggal Pendaftaran",
        namaPerusahaan:"Nama Perusahaan",
        kodeKantor:"Kode Kantor",
        tanggalRespon:"Tanggal Respon",
        jalur:"Jalur",
        namaRespon:"Nama Respon",
        create_document:"Create Document",
        document_id:"Document ID",
        keterangan_lain:"Keterangan Lain",
        nomor_identitas:"Nomor Identitas",
        tipe_identitas:"Tipe Identitas",
        api_nib:"API/NIB",
        referensi:"Referensi",
        referensi_importir:"Referensi Importir",
        salin_importir:"Salin Inportir",
        referensi_pemilik_barang:"Referensi Pemilik Barang",
        npwp_pemusatan:"NPWP Pemusataan",
        salin_pengirim:"Salin Data Pengirim",
        proRate:"Pro Rate",
        akumFlag:"Accumulaiton",
        type_api:"Tipe API/NIB",
        rateBaseDesc:"Rate Base Description",
        HI_QTY_CS:"Qty CS HI (Each)",
        HO_QTY_CS:"Qty CS HO (Each)",
        sumQtyAkumActvity:"Qty CS HI + HO (Each)",
        qtyExcess:"Qty Excess (Each)",
        excessFlag:"Excess Flag",
        cmlDetailDataAkumActivity:"CML Detail Data Accumulation Activity",
        dataAkumulasi:"Data Accumulation Activity",
        QTY_CS:"Qty CS (Each)",
        grossWeight:"Gross Weight",
        idSubBillingDetail:"Id Sub Billing Detail",
        qtyChargeExcess:"Qty Charge (Excess)",
        seri:"Seri",
        jenis_dokumen:"Jenis Dokumen",
        nomorNya:"Nomor",
        fasilitas:"Fasilitas",
        tanggal:"Tanggal",
        izin:"Izin",
        kantor:"Kantor",
        dokumen_lampiran:"Dokumen Lampiran",
        nomor_dokumen:"Nomor Dokumen",
        tanggalDokumen:"Tanggal Dokumen",
        selanjutnya:"Selanjutnya",
        fasilitas_dokumen:"Fasilitas Dokumen",
        nomor_tutup_pu:"Nomor Tutup PU",
        nomor_pos:"Nomor POS",
        nomor_subpos:"Nomor Sub POS",
        pengangkutan: "Pengangkutan",
        nama_sarana_angkut: "Nama Sarana Angkut",
        no_voy_no_pol: "Nomor Voy/Flight/No.Pol",
        perkiraan_tanggal: "Perkiraan Tanggal",
        pelabuhan_penimbunan: "Pelabuhan & Tempat Penimbunan",
        tempat_penimbunan:"Tempat Penimbunan",
        calculationQty: "Calculation Considerations",
        kemasan_petiKemas: "Kemasan & Peti Kemas",
        peti_kemas:"Peti Kemas",
        jenis:"Jenis",
        jumlah:"Qty",
        merk:"Merk",
        ukuran:"Ukuran",
        harga_lainnya:"Harga Lainnya",
        valuta:"Valuta",
        jenis_transaksi:"Jenis Transaksi",
        harga_barang:"Harga Barang",
        nilai_pabean:"Nilai Pabean",
        biaya_penambah:"Biaya Penambah",
        biaya_pengurang:"Biaya Pengurang",
        freight:"Freight",
        asuransi:"Asuransi",
        voluntary_declaration:"Voluntary Declaration",
        berat_bersih:"Berat Bersih (KGM)",
        berat_kotor:"Berat Kotor (KGM)",
        barang_txt:"Barang",
        uraian_txt:"Uraian",
        nilai_barang:"Nilai Barang",
        jumlah_satuan:"Jumlah Satuan",
        jenis_satuan:"Jenis Satuan",
        pernyataan:"Pernyataan",
        billingPeriode:"Billing Periode Cut Off",
        additionalDataWMSFlag:"Upload Additional Handling Wms",
        sapDataFlag:"Upload Data SAP",
        overtime:"Overtime",
        trxSap:"Transaction SAP",
        addHandlingWms:"Additional Handling Wms",
        addStorageWms:"Additional Storage Wms",
        extraHandling:"Extra Handling",
        uploadDataAdditionalStorageWms:"Upload Data Additional Storage Wms",
        downloadTemplateDataAdditionalStorageWms:"Download Template Data Additional Storage Wms",
        idRate:"Id Rate",
        tariffMasterId:"Tariff Master Wms",
        hs_code:"HS Code",
        groupCategory:"Group Category",
        seqNumAkum:"Seq Num Akum",
        historyDownload:"History Download",
        created_by:"Created By",
        updated_by:"Updated By",
        updated_at:"Updated At",
        namaImportir:"Nama Importir",
        salesSurvey:"Sales Survey",
        salesSurveyDetail:"Sales Suvey Detail",
        salesSurveyUpdate:"Sales Suvey Update",
        salesSurveyUpload:"Sales Suvey Upload",
        salesSurveySummary:"Summary Report",
        salesSurveyPriority:"Priority Report",
        weeklyTransmitFlag:"Weekly Transmit",
        begBalRentPallFlag:"Rental Pallet Beginning Balance",
        queryBegBalRentPall:"Query Rental Pallet Beginning Balance",
        qtyBegBalRentPall:"Rental Pallet Beg Bal",
        subDetailRateFlag:"Sub Detail Rate",
        subDetailRateHandling:"Sub Detail Rate Handling",
        create_rate_detail_subhandling:"Create Sub Detail Rate Handling",
        detail_rate_detail_subhandling:"Detail Sub Detail Rate Handling",
        update_rate_detail_subhandling:"Update Sub Detail Rate Handling",
        cmlDetailHandlingByLocCat:"CML Billing Detail Handling By Location Category",
        idDetailHandling:"ID Detail Handling",
        role_access_warehouse:"Role Access",
        billing_mapping_role_access:"Role Access - Billing Mapping",
        billing_mapping_role_access_detail:"Detail Role Access - Billing Mapping",
        mapping_id:"Mapping ID",
        role_id:"Role ID",
        warehouse:"Warehouse",
        warehouse_id:"Warehouse ID",
        warehouse_name:"Warehouse Name",
        billing_mapping_role_access_edit:"Edit Role Access - Billing Mapping",
        role_name:"Role Name",
        warehouse_empty_error: "The warehouse list cannot be empty !",
        select_all: "Select All",
        unselect_all: "Unselect All",
        role_access: "Role Access",
        billing_mapping_role_access_create:"Create Role Access - Billing Mapping",
        access_to: "Access To",
    },
    "id": {
        access_to: "Access To",
        billing_mapping_role_access_create:"Create Role Access - Billing Mapping",
        role_access: "Role Access",
        unselect_all: "Unselect All",
        select_all: "Select All",
        warehouse_empty_error: "The warehouse list cannot be empty !",
        role_name:"Role Name",
        billing_mapping_role_access_edit:"Edit Role Access - Billing Mapping",
        warehouse_name:"Warehouse Name",
        warehouse_id:"Warehouse ID",
        warehouse:"Warehouse",
        role_id:"Role ID",
        mapping_id:"Mapping ID",
        billing_mapping_role_access_detail:"Detail Role Access - Billing Mapping",
        billing_mapping_role_access:"Role Access - Billing Mapping",
        role_access_warehouse:"Role Access",
        idDetailHandling:"ID Detail Handling",
        cmlDetailHandlingByLocCat:"CML Billing Detail Handling By Location Category",
        create_rate_detail_subhandling:"Create Sub Detail Rate Handling",
        detail_rate_detail_subhandling:"Detail Sub Detail Rate Handling",
        update_rate_detail_subhandling:"Update Sub Detail Rate Handling",
        subDetailRateHandling:"Sub Detail Rate Handling",
        subDetailRateFlag:"Sub Detail Rate",
        qtyBegBalRentPall:"Rental Pallet Beg Bal",
        queryBegBalRentPall:"Query Rental Pallet Beginning Balance",
        begBalRentPallFlag:"Rental Pallet Beginning Balance",
        weeklyTransmitFlag:"Transmisi Mingguan",
        salesSurveySummary:"Laporan Total Kalkulasi",
        salesSurveyPriority:"Laporan Prioritas",
        salesSurveyUpload:"Upload Sales Suvey",
        salesSurveyUpdate:"Update Suvey Update",
        salesSurveyDetail:"Detail Sales Suvey",
        salesSurvey:"Sales Survey",
        namaImportir:"Nama Importir",
        updated_at:"Updated At",
        updated_by:"Updated By",
        created_by:"Created By",
        historyDownload:"History Download",
        seqNumAkum:"Seq Num Akum",
        groupCategory:"Group Category",
        hs_code:"HS Code",
        idRate:"Id Rate",
        tariffMasterId:"Tariff Master Wms",
        downloadTemplateDataAdditionalStorageWms:"Download Template Data Additional Storage Wms",
        uploadDataAdditionalStorageWms:"Upload Data Additional Storage Wms",
        extraHandling:"Extra Handling",
        overtime:"Overtime",
        trxSap:"Transaction SAP",
        addHandlingWms:"Additional Handling Wms",
        addStorageWms:"Additional Storage Wms",
        sapDataFlag:"Upload Data SAP",
        additionalDataWMSFlag:"Upload Additional Handling Wms",
        pernyataan:"Pernyataan",
        billingPeriode:"Periode Penagihan Dipotong",
        jenis_satuan:"Jenis Satuan",
        jumlah_satuan:"Jumlah Satuan",
        nilai_barang:"Nilai Barang",
        uraian_txt:"Uraian",
        barang_txt:"Barang",
        berat_bersih:"Berat Bersih (KGM)",
        berat_kotor:"Berat Kotor (KGM)",
        voluntary_declaration:"Voluntary Declaration",
        asuransi:"Asuransi",
        freight:"Freight",
        biaya_penambah:"Biaya Penambah",
        biaya_pengurang:"Biaya Pengurang",
        nilai_pabean:"Nilai Pabean",
        harga_barang:"Harga Barang",
        valuta:"Valuta",
        jenis_transaksi:"Jenis Transaksi",
        harga_lainnya:"Harga Lainnya",
        ukuran:"Ukuran",
        jenis:"Jenis",
        jumlah:"Jumlah",
        merk:"Merk",
        peti_kemas:"Peti Kemas",
        kemasan_petiKemas:"Kemasan & Peti Kemas",
        tempat_penimbunan:"Tempat Penimbunan",
        pelabuhan_penimbunan:"Pelabuhan & Tempat Penimbunan",
        perkiraan_tanggal:"Perkiraan Tanggal",
        no_voy_no_pol : "Nomor Voy/Flight/No.Pol",
        nama_sarana_angkut:"Nama Sarana Angkut",
        calculationQty:"Calculation Considerations",
        pengangkutan:"Pengangkutan",
        nomor_subpos:"Nomor Sub POS",
        qtyChargeDays:"Qty Charge Days",
        nomor_pos:"Nomor POS",
        nomor_tutup_pu:"Nomor Tutup PU",
        fasilitas_dokumen:"Fasilitas Dokumen",
        selanjutnya:"Selanjutnya",
        tanggalDokumen:"Tanggal Dokumen",
        nomor_dokumen:"Nomor Dokumen",
        dokumen_lampiran:"Dokumen Lampiran",
        kantor:"Kantor",
        izin:"Izin",
        tanggal:"Tanggal",
        fasilitas:"Fasilitas",
        nomorNya:"Nomor",
        jenis_dokumen:"Jenis Dokumen",
        seri:"Seri",
        qtyChargeExcess:"Qty Charge (Excess)",
        idSubBillingDetail:"Id Sub Billing Detail",
        grossWeight:"Gross Weight",
        QTY_CS:"Qty CS (Each)",
        dataAkumulasi:"Data Akumulasi Aktifitas",
        cmlDetailDataAkumActivity:"CML Detail Data Akumulasi Aktifitas",
        excessFlag:"Excess Flag",
        qtyExcess:"Qty Excess (Each)",
        sumQtyAkumActvity:"Qty CS HI + HO (Each)",
        HO_QTY_CS:"Qty CS HO (Each)",
        HI_QTY_CS:"Qty CS HI (Each)",
        rateBaseDesc:"Rate Base Description",
        type_api:"Tipe API/NIB",
        tipe_identitas:"Tipe Identitas",
        salin_pengirim:"Salin Data Pengirim",
        npwp_pemusatan:"NPWP Pemusataan",
        akumFlag:"Accumulaiton",
        proRate:"Pro Rate",
        referensi_pemilik_barang:"Referensi Pemilik Barang",
        salin_importir:"Salin Inportir",
        referensi_importir:"Referensi Importir",
        referensi:"Referensi",
        api_nib:"API/NIB",
        nomor_identitas:"Nomor Identitas",
        keterangan_lain:"Keterangan Lain",
        document_id:"ID Dokument",
        create_document:"Buat Dokument",
        namaRespon:"Nama Respon",
        jalur:"Jalur",
        tanggalRespon:"Tanggal Respon",
        kodeKantor:"Kode Kantor",
        namaPerusahaan:"Nama Perusahaan",
        tanggalAju:"Tanggal Pendaftaran",
        nomorAju:"Nomor Pengajuan",
        kodeDokumen:"Kode Dokumen",
        dokumen_pabean:"Dokumen Pabean",
        customer_update:"Ubah Customer",
        customer_create:"Buat Customer",
        customer_type:"Tipe Customer",
        customer_upload:"Customer Upload",
        nib:"NIB",
        identity_number:"Nomor Identitas",
        master_bl_awb:"Master-BL/AWB",
        house_bl_awb:"House-BL/AWB",
        transaksi:"Transaksi",
        invoice:"Invoice",
        pelabuhan_tujuan:"Pelabuhan Tujuan",
        pelabuhan_transit:"Pelabuhan Transit",
        pelabuhan_muat:"Pelabuhan Muat",
        perkiraaan_tanggal_tiba:"Perkiraan Tangggal Tiba",
        bendera:"Bendera",
        no_voy:"No. Voy/Flight",
        sarana_pengangkutan:"Sarana Pengangkutan",
        cara_pengangkutan:"Cara Pengangkutan",
        importir:"IMPORTIR",
        identitas:"Identitas",
        pemilik_barang:"PEMILIK BARANG",
        penjual:"PENJUAL",
        kode_negara:"Kode Negara",
        negara:"Negara",
        alamat:"Alamat",
        nama:"Nama",
        pengirim:"PENGIRIM",
        ppjk_create:"Buat PPJK",
        ppjk_edit:"Ubah PPJK",
        ppjk_detail:"Detail PPJK",
        np_ppjk:"No PPJK",
        no_npwp:"No NPWP",
        ppjk:"PPJK",
        create_client_login:"Buat Klien Login",
        ppjk_id:"PPJK ID",
        ppjk_name:"Nama PPJK",
        cara_pembayaran:"Cara Pembayaran",
        nomor_pengajuan:"Nomor Pengajuan",
        kantor_pabean:"Kantor Pabean",
        header:"Header",
        detail_barang:"Detail Barang",
        entitas:"Entitas",
        kemasan:"Kemasan",
        kontainer:"Kontainer",
        dokumen:"Dokumen",
        pengangkut:"Pengangkut",
        jenis_pib:"Jenis PIB",
        jenis_impor:"Jenis Impor",
        pib:"PEMBERITAHUAN IMPOR BARANG (PIB)",
        dukumen_impor:"Dokumen Impor",
        create:"Buat",
        endpoint:"Endpoint",
        client_id:"ID Klien",
        system_code_id:"System Code ID",
        master_data:"Data Master",
        client_login:"Klien Login",
        client_login_edit:"Ubah Klien Login",
        system_code:"Kode Sistem",
        system_code_detail:"Detail Kode Sistem",
        system_code_create:"Buat Kode Sistem",
        system_code_upload:"Unggah Kode Sistem",
        master_Data:"Data Master",
        ceisa:"CEISA DJBC",
        yourRemarks:"Catatan",
        bca:"BCA",
        blujayBcaUserMappingLocationTxt:"User Mapping Location",
        blujayBcaMasterLocationTxt:"Master Location",
        queryBeginningBalance:"Query Storage Beginning Balance",
        beginningBalanceFlag:"Storage Beginning Balance",
        qtyBeginningBalance:"Storage Beg Bal",
        totalRowInterfaces:"Data Interface",
        idLocCategory:"Id Location Category",
        idMaster_Warehouse:"Id Master Warehouse",
        idMaster_Customer:"Id Master Customer",
        palletType:"Pallet Type",
        sumQty:"Sum Qty Charge",
        idSummaryStorageQty:"ID Sum Strg Qty",
        cmlDetailSumStrgQty:"CML Billing Detail Summary Storage Qty",
        lotAtt07:"Rental Pallet Type",
        dashboardLincMiddleware:"Dashboard Linc Middleware",
        companyAccessFulfillment:"Company Access Fulfillment",
        userAccessCompany:"User Access Company",
        downloadTemplateMasterSKU:"Download Template Master Sku",
        oms_user_customer_mapping_id:"OMS User Mapping ID",
        userOmsTxt:"User Mapping",
        customer_fulfillment_id:"Company Fulfillment ID",
        company_name:"Company Name",
        company_code:"Company Code",
        company_id:"Company ID",
        interface:"Interface",
        inbound_asn:"Inbound (ASN)",
        inbound_po:"Inbound (PO)",
        list:"Daftar",
        outbound:"Outbound (SO)",
        flux_oms:"Flux OMS",
        dataRate:"Data Rate",
        typeName:"Type Name",
        titleCmlDetailLogsSyncTrx:"CML Detail Logs Sync Trx",
        countRowInternal:"Total Rows Insert Data",
        countRowEksternal:"Total Rows Get Data",
        trxTypeName:"Transaction Type Name",
        idLog:"Id Log",
        downloadTemplateTariffMaster:"Download Template Tariff Master",
        massUploadTariffMaster:"Mass Upload Data Tariff Master",
        quantity:"Quantity",
        price:"Harga",
        product_Desc:"Deskripsi Produk",
        product_code:"Kode Produk",
        idRateDetailSalesForce:"Id Rate Detail SF",
        detail_opportunity:"Detail Opportunity",
        sales_force_opportunity_detail:"Sales Force Opportunity Billing Detail",
        billing_opportunity:"Opportunity Billing",
        opportunity:"Opportunity",
        sales_force_opportunity:"Sales Force Opportunity Billing",
        idRateSalesForce:"Id Rate SF",
        sales_force:"Sales Force",
        idRateBase:"Id Rate Base",
       
        arrNo:"Arrival No",
        opportunity_id:"Opportunity ID",
        contract_no:"Contract No",
        cml_billing_detail_equipment_type:"CML Billing Detail Equipment Type",
        cml_billing_detail_equipment_type_add:"CML Billing Detail Equipment Type Additional",
        cml_billing_detail_handling_out_add:"CML Billing Detail Handling Out Additional",
        cml_billing_detail_handling_in_add:"CML Billing Detail Handling In Additional",
        DataCustSapTotalRowsCancelCount:"Total Rows Cancel",
        recalcMatchData:"Recalculate Amount + Match Data",
        downloadDataList:"Daftar Unduh Data",
        cml_wms_code:"CML WMS Code",
        cml_rate_base:"CML Rate Base",
        cml_tariff_master:"CML Tariff Master",
        cml_location:"CML Lokasi",
        cmlDetailSumStrgMuid:"CML Billing Detail Summary Storage Pallet Used MUID",
        cmlDetailSumStrgPltUsd:"CML Billing Detail Summary Storage Pallet Used",
        cmlDetailStorageByLocCat:"CML Billing Detail Storage By Location Category",
        cmlDetailSubStorage:"CML Billing Detail Sub Storage",
        lineNo:"Line No",
        downloadDataWMS:"Unduh Data WMS",
        DataCustSapUnmatchCount:"Total Baris Unmatch",
        DataCustSapMatchCount:"Total Baris Match",
        DataCustSapTotalRowsCount:"Total Baris Data SAP",
        key1:"Kunci",
        sloc:"Sloc",
        plant:"Plant",
        additionalFlag:"Data Tambahan",
        dataMatchingProcess:"Pencocokan Data",
        reference:"Reference",
        userName:"Username",
        debitOrCredit:"Debit Or Credit",
        purchaseOrder:"Purchase Order",
        docHeader:"Doc Header",
        materialDesc:"Material Description",
        qtyUnit:"Qty Unit",
        postDate:"Post Date",
        materialDoc:"Material Doc",
        movementType:"Movement Type",
        storageLocation:"Storage Location",
        plantCode:"Plant Code",
        materialNo:"Material No",
        idMatch:"ID Match",
        idDetailCust:"ID Detail Cust",
        titleCmlDetailDataSAP:"CML Detail Data SAP",
        dataSAP:"Data SAP",
        downloadTemplateDataAdditionalWMS:"Unduh Template Data Tambahan WMS",
        uploadDataAdditionalWMS:"Unggah Data Tambahan WMS",
        messageTxt:"Pesan",
        no:"No",
        downloadTemplateDataSAP:"Unduh Template Data SAP",
        uploadDataSAP:"Upload Data SAP",
        sumCbmMultiWh:"Sum CBM Multi Warehouse",
        qtyPerCase:"Qty Per Case",
        qtyPerPallet:"Qty Per Pallet",
        qtyEach:"Qty Each",
        sumPalletUsedSkuBatch:"Sum Qty Pallet Used Sku Batch",
        logic_info:"Info Logika",
        recalculateAmount:"Hitung Ulang Jumlah",
        recalculateByDate:"Hitung Ulang Berdasarkan Tanggal",
        idSumStrgPltUsed:"ID Plt Used",
        minQtyFlag:"Min Qty",
        interfaceStatus:"Interface Status",
        status:"Status",
        amount:"Amount",
        sumQtyCharge:"Sum Qty Charge Multi Warehouse",
        sumCBM:"Sum CBM",
        sumQtyOnhand:"Sum Qty OnHand",
        sumPalletUsed:"Sum Qty Pallet Used",
        idSummaryStorage:"ID Sum Storage",
        idSummaryStorageMuid:"ID Summary Storage Muid",
        summaryFlag:"Summary",
        multi_warehouse_flag:"Multi Warehouse",
        datas_response_xml:"Datas Response XML",
        datas_structure_xml:"Datas Structure XML",
        datas_xml:"Datas XML",
        datas_response:"Datas Response",
        datas_structure:"Datas Structure",
        datas:"Datas",
        in_selection:"In Selection",
        clear_calender:"Clear Calender",
        reset_filter_txt:"Reset Filter",
        success:"Success",
        error:"Error",
        created_at:"Created At",
        filename:"File Name",
        id:"ID",
        chain:"Chain",
        blujay:"Blujay",
        referenceNo:"Reference No",
        idSummaryHandling:"ID Summary Handling",
        cml_billing_detail_summary_handling_charge:"CML Billing Detail Summary Handling",
        cml_billing_detail_summary_storage:"CML Billing Detail Summary Storage Multi Warehouse",
        cml_billing_detail_summary_storage_muid:"CML Billing Detail Summary Storage MUID",
        cml_billing_detail_summary_storage_pltused:"CML Billing Detail Summary Storage Pallet Used",
        maxQty:"Max Qty",
        please_choose_one:"Please Choose One",
        form_upload_data:"Form Upload Data",
        upload_billing_list:"Upload Billing List",
        itemCategory:"Item Category",
        locCategoryCode:"Location Category Code",
        locCategory:"Location Category",
        detail_wms_code:"Detail WMS Code",
        defaultFlag:"Default Flag",
        outerCode:"Outer Code",
        showSeq:"Show Sequence",
        codeDesc:"Code Description",
        codeId:"Code ID",
        codeType:"Code Type",
        idWmsCode:"ID WMS Code",
        wms_code:"WMS Code",
        trxDate:"Transaction Date",
        idEstimation:"ID Estimation",
        storage_estimation:"Storage Estimation",
        cml_billing_detail_minimum_charge:"CML Billing Detail Minimum Charge",
        idDetailMinimumCharge:"ID Detail Minimum Charge",
        cml_billing_detail_rental_pallet:"CML Billing Detail Rental Pallet",
        idDetailRentalPallet:"ID Detail RP",
        idTarifMasterHeader:"ID Tariff",
        detail:"Detail",
        totalHourOt:"Total Hour OT",
        cml_billing_detail_handling_vas:"CML Billing Detail VAS",
        idDetailVAS:"ID Detail VAS",
        download_attachment:"Download Attachment",
        sid:"SID",
        wa_message_detail:"Detail WA Message",
        wa_message_update:"Update WA Message",
        attachment:"Attachment",
        message:"Message",
        app_form:"APP From",
        wa_message_create:"Create WA Message",
        wa_message_data:"WA Message Data",
        wa_master_phone_number:"WA Master Phone Number",
        type:"Tipe",
        code:"Kode",
        from_phone_number:"From Phone Number",
        id_whatsapp_msg:"ID WA MSG",
        minQty:"Min Qty",
        minAmount:"Min Amount",
        totalWorkDay:"Total WorkDay",
        amountOt:"Amount OT",
        rateOt:"Rate OT",
        cml_billing_detail_handling_extra_handling:"CML Billing Detail Handling Extra Handling",
        grandTotal:"Grand Total",
        ppn:"PPN",
        amountPpn:"Amount PPN",
        ppH:"PPH",
        amountPph:"Amount PPH",
        amountManagement:"Amount Management",
        rateManagement:"Rate Management",
        totalKotor:"Total Kotor",
        jaminanPensiun:"Jaminan Pensiun",
        bpjsTk:"BPJS Tk",
        bpjsKes:"BPJS Kes",
        subTotal:"Sub Total",
        adjustmentDown:"Adjustment Down",
        adjustmentUp:"Adjustment Up",
        tunjangan:"Tunjangan",
        salary:"Salary",
        upload_extra_handling:"Upload Extra Handling",
        uploadDataExtraHandling:"Upload Data Extra Handling",
        basicSalary:"Basic Salary",
        idDetail_ExtraHandling:"ID Detail EH",
        download_template_extra_handling:"Download Template Extra Handling",
        total_amount:"Total Amount",
        overtimeType:"Overtime Type",
        sbu_sku:"SBU SKU",
        cml_billing_detail_handling_overtime:"CML Billing Detail Handling Overtime",
        hourOvertime:"Hour Overtime",
        position:"Position",
        transactionType:"Transaction Type",
        idDetail_Overtime:"ID Detail Overtime",
        cml_billing_detail_handling_storage_sub:"ID Detail Handling Sub Storage",
        cml_billing_detail_handling_storage:"ID Detail Handling Storage",
        idDetailHandlingOut:"ID Detail HO",
        cml_billing_detail_handling_out:"CML Billing Detail Handling Out",
        cml_billing_detail_handling_in:"CML Billing Detail Handling In",
        totalPallet:"Total Pallet",
        totalArea:"Total Area",
        soReference:"SO Reference",
        qtyCase:"Qty Case",
        qtyEA:"Qty Each",
        batch:"Batch",
        poReference:"PO Reference",
        idDetailHandlingIn:"ID Detail HI",
        cml_billing_detail_storage:"CML Billing Detail Storage",
        totalCube:"Total Cube",
        cube:"Cube",
        qtyPallet:"Qty Pallet",
        qtyOnCases:"Qty On Case",
        qtyOnHand:"Qty On Hand",
        MUID:"MUID",
        locationId:"Location ID",
        traceId:"Trace ID",
        keyLocation:"Key Location",
        idSubDetailStorage:"ID Sub Detail Storage",
        zone:"Zone",
        idDetailStorage:"ID Detail Storage",
        rate:"Rate",
        qtyCharge:"Qty Charge",
        idBillingDetail:"Id Billing Detail",
        message_data:"Message Data",
        waStatus:"WA Status",
        edit_master_phone_number:"Rubah Master Phone Number",
        master_phone_number_id:"Master Phone Number ID",
        qr:"QR",
        waBrowserId:"WA Browser Id",
        waSecretBundle:"WA Secret Bundle",
        waToken1:"WA Token 1",
        waToken2:"WA Token 2",
        skuMasterAdd:"Tambah Master SKU",
        soMasterAdd:"Tambah Pesanan Pengiriman",
        soMasterEdit:"Ubah Master SKU",
        detail_master_phone_number:"Detail Master Phone Number",
        master_phone_create:"Create Master Phone",
        phone_number:"Phone Number",
        phone_name:"Phone Name",
        master_phone_number:"Master Phone Number",
        whatsapp:"Whatsapp",
        pleaseSelectCompanyAndWarehouse : "Silahkan pilih Perusahaan dan Gudang terlebih dahulu",
        cml_billing_create : "Create Billing CML",
        cml_billing_edit : "Edit Billing CML",
        idBillingHeader:"ID Billing",
        cml_billing_detail : "CML Billing Detail",
        cml_billing : "CML Billing",
        transactionToDate:"Transaction To Date",
        transactionFromDate:"Transaction From Date",
        rate_detail_substorage:"Sub Detail Rate Storage",
        create_rate_detail_substorage:"Create Sub Detail Rate Storage",
        detail_rate_detail_substorage:"Detail Sub Detail Rate Storage",
        update_rate_detail_substorage:"Update Sub Detail Rate Storage",
        rate_detail_storage:"Rate Detail Storage",
        create_rate_detail_storage:"Create Sub Detail Rate Storage",
        detail_rate_detail_storage:"Detail Sub Detail Rate Storage",
        update_rate_detail_storage:"Update Sub Detail Rate Storage",
        rate_detail_handling:"Rate Detail Handling",
        create_rate_detail_handling:"Create Rate Detail Handling",
        detail_rate_detail_handling:"Detail Rate Detail Handling",
        update_rate_detail_handling:"Edit Rate Detail Handling",
        detailStorage:"Detail Storage",
        detailHandling:"Detail Handling",
        idRateHeader:"ID Rate",
        zona:"Zona",
        masterLocations:"Location",
        tarifMasteEdit:"Edit Tariff Master",
        tarifMasterDetail:"Detail Tariff Master",
        tarifMasterAdd:"Create Tariff Master",
        tarifMasterId:"Tariff Master Wms",
        tarifMasterTxt:"Tariff Master",
        organizationId:"Organization Id",
        cml_rate:"CML Rate",
        rateDesc:"Rate Description",
        tariffId:"Tarif ID",
        history_sync:"History Sync",
        downloadXml:"Download XML",
        udf02SAPCode:"UDF02SAPCODE",
        udf01Aag:"AAG",
        salesOffice:"Sales Office",
        salesGroup:"Sales Group",
        qty_cases:"QTY Cases",
        qty_each:"QTY Each",
        qty_charge:"QTY Charge",
        cbm:"CBM",
        storageType:"Storage Type",
        link_download:"Link Download",
        historyData:"History Data",
        skuGroup:"SKU Group",
       
        asnReference1:"ASN Reference 1",
        airwayBill:"Air wayBill",
        omsNumber:"OMS Number",
        form_download_data:"Form Download  Data",
        vasType:"VAS Type",
        uploadDataVAS:"Unggah Data VAS",
        uploadDataOvertime:"Unggah Data Overtime",
        inSelection:"In Selection",
        clearCalender:"Clear Calendar",
        confirmed:"Konfirmasi",
        recalculate:"Hitung Ulang",
        query:"Query",
        unselect_data_txt:"Unselect Data",
        shipmentDate:"Shipment Date",
        stockDate:"Stock Date",
        locationCategory:"Location Category",
        totalOvertime:"Total Overtime",
        breakTime:"Break Time",
        endOvertime:"End Overtime",
        startOvertime:"Start Overtime",
        nik:"NIK",
        changeStatus:"Change Status",
        uom:"Uom",
        docType:"Doc Type",
        receiveDate:"Receive Date",
        docLineNo:"Doc Line No",
        docNo_filter:"Filter By Doc No",
        docNo:"Doc No",
        billing_sub_detail_txt:"Sub Detail",
        amountCategory:"Amount Category",
        billing_category_detail_txt:"Billing Category",
        billingId:"Billing ID",
        download_template_overtime:"Download Template Overtime",
        upload_overtime:"Upload Overtime",
        download_template_vas:"Download Template VAS",
        upload_Overtime:"Upload Overtime",
        upload_vas:"Upload Vas",
        billing_summary_detail_txt:"Detail Billing Summary Category",
        billing_detail_txt:"Billing Detail",
        edit_billing_header_txt:"Edit Billing Header",
        amount_txt:"Amount",
        cli_billing:"CLI Billing",
        edit_rate_header_txt:"Edit Rate Header",
        edit_rate_detail_txt:"Edit Rate Detail",
        dashboardBillingTxt:"Dashboard Billing",
        addwho:"Created By",
        adddate:"Created At",
        editwho:"Updated By",
        editdate:"Updated At",
        detail_rate_detail_txt:"Detail Rete Detail",
        create_rate_detail_txt:"Create Rete Detail",
        addDetail:"Add Detail",
        tierQty:"Tier QTY",
        tierQty_filter:"Filter By Tier QTY",
        remark_filter:"Filter By Remarks",
        ratePerUnit:"Rate Per Unit",
        ratePerUnit_filter:"Filter By Rate Per Unit",
        tier:"Tier",
        tier_filter:"Filter By Tier",
        SAPDivision:"SAP Division",
        SAPDivision_filter:"Filter By SAP Division",
        SAPMaterialCode:"SAP Material Code",
        SAPMaterialCode_filter:"Filter By SAP Material Code",
        chargeCategory_txt:"Charge Category",
        chargeCategory_filter_txt:"Filter By Charge Category",
        applyTxt:"Apply",
        firstBilingDate_txt:"First Billing Date",
        effectiveDate_txt:"Effective Date",
        transactionDate_txt:"Transaction Date",
        rate_create:"Create Billing Rate",
        customerName_filter_txt:"Filter By Customer Name",
        customerName_txt:"Customer Name",
        customerId_filter_txt:"Filter By Customer ID",
        customerId_txt:"Customer ID",
        CliMasterCustomerTxt:"CLI Master Customer",
        CmlMasterCustomerTxt:"CML Customer",
        MasterCustomerTxt:"Customer",
        activeFlag_filter_txt:"Filter By Active Flag",
        warehouseDescr_filter_txt:"Filter By Warehouse Description",
        activeFlag_txt:"Active Flag",
        warehouseDescr_txt:"Warehouse Description",
        MasterWarehouseTxt:"Warehouse",
        CliMasterWarehouseTxt:"CLI Master Warehouse",
        CmlMasterWarehouseTxt:"CML Warehouse",
        effectiveToDate:"Effective To Date",
        effectiveToDate_filter:"Filter By Effective To Date",
        effectiveFromDate:"Effective From Date",
        effectiveFromDate_filter:"Filter By Effective From Date",
        firstBilingDate_filter:"Filter By First Blling Date",
        firstBilingDate:"First Blling Date",
        customerSAPCode:"Customer SAP Code",
        customerSAPCode_filter:"Filter By Customer SAP Code",
        customerGroup:"Customer Group",
        customerGroup_filter:"Filter By Customer Group",
        customerId:"Customer ID",
        customerId_filter:"Filter By Customer ID",
        warehouseId_filter_txt:"Filter By Warehouse ID",
        warehouseId_txt:"Warehouse ID",
        rateName_filter_txt:"Filter By Rate Name",
        rateName_txt:"Rate Name",
        cli_rate:"CLI Rate",
        billing_txt:"Billing",
        rate_txt:"Rate",
        rate_detail_txt:"Rate Detail",
        cli_txt:"CLI",
        cml_txt:"CML",
        detail_bm_code_txt:"Detail BM Code",
        update_bm_code_txt:"Ubah BM Code",
        create_bm_code_txt:"Buat BM Code",
        create_customer_txt:"Create Customer",
        rateBase_filter_txt:"Filter By Rate Base",
        rateBaseDetail:"Rate Base Detail",
        ratebaseAdd:"Create Ratebase",
        ratebaseEdit:"Edit Ratebase",
        rateBase_txt:"Rate Base",
        rateBaseName_txt:"Ratebase Name",
        rateBaseDesc_txt:"Rate Base Description",
        materialCode_filter_txt:"Pencarian Berdasarkan Kode Bahan",
        materialCode_txt:"Kode Bahan",
        chargeType_filter_txt:"Pencarian Berdasarkan Jenis Biaya",
        chargeType_txt:"Charge Type",
        categoryCode_txt:"Kode Kategori",
        categoryCode_filter_txt:"Pencarian Berdasarkan Kode Kategori",
        BmCodelkupTxt:"BM Code",
        warehouse_system_code_edit:"Ubah Warehouse System Code",
        system_code_edit:"Ubah System Code",
        customer_id:"ID Pelanggan",
        warehouse_system_code_create:"Buat Warehouse System Code",
        wsc01:"wsc01",
        wsc02:"wsc02",
        wsc03:"wsc03",
        wsc04:"wsc04",
        wsc05:"wsc05",
        wsc06:"wsc06",
        wsc07:"wsc07",
        wsc08:"wsc08",
        wsc09:"wsc09",
        wsc10:"wsc10",
        udf01:"udf01",
        udf02:"udf02",
        udf03:"udf03",
        udf04:"udf04",
        udf05:"udf05",
        default_flag:"Default Flag",
        active_flag:"Active Flag",
        show_sequence:"Show Sequence",
        outer_code:"Outer Code",
        code_id:"ID Code",
        warehouse_system_code_detail:"Detail Warehouse System Code",
        field_issue:"Field Issue",
        response_issue:"Response Issue",
        return_issue:"Masalah Pengembalian",
        code_description:"Deskripsi Kode",
        code_description_filter:"Pencarian Berdasarkan Deskripsi Kode",
        code_type:"Tipe Kode",
        code_type_filter:"Pencarian Berdasarkan Tipe Kode",
        category_filter:"Pencarian Berdasarkan Kategori",
        category:"Kategori",
        warehouse_system_code:"Kode Sistem Gudang",
        billing:"Billing",
        fulfillment_edit:"Ubah Gudang",
        fulfillment_detail:"Detail Gudang",
        stacking:"Penumpukan",
        max_pallet:"Mak Pallet",
        luas_area_pallet:"Luas Area Pallet",
        pallet_size:"Ukuran Pallet",
        total_area:"Luas Total",
        mover_area:"Area Penggerak",
        area_palet:"Palet Area",
        fulfillmentAddTxt:"Tambah Data Gudang",
        fulfillment_description:"Deskripsi Gudang",
        fulfillment_center_id:"ID Gudang",
        fulfillment_description_filter:"Pencarian Berdasarkan Deskripsi Gudang",
        fulfillment_code_filter:"Pencarian Berdasarkan Kode Gudang",
        fulfillment_code:"Kode Gudang",
        fulfillment_name:"Nama Gudang",
        fulfillment:"Gudang",
        customer_edit:"Ubah Pelanggan",
        customer_detail:"Detail Pelanggan",
        billing_customer_c01:"Formulir Tambahan 1",
        billing_customer_c02:"Formulir Tambahan 2",
        billing_customer_c03:"Formulir Tambahan 3",
        billing_customer_c04:"Formulir Tambahan 4",
        billing_customer_c05:"Formulir Tambahan 5",
        billing_customer_c06:"Formulir Tambahan 6",
        billing_customer_c07:"Formulir Tambahan 7",
        billing_customer_c08:"Formulir Tambahan 8",
        billing_customer_c09:"Formulir Tambahan 9",
        billing_customer_c10:"Formulir Tambahan 10",
        company_group_id:"ID Perusahaan Group",
        customer_description:"Deskripsi Pelanggan",
        customer_description_filter:"Pencarian Berdasarkan Deskripsi Pelanggan",
        customer_code:"Kode Pelanggan",
        customer_code_filter:"Pencarian Berdasarkan Kode Pelanggan",
        create_company_group_txt:"Buat Group Perusahaan",
        company_group_description_txt:"Deskripsi Group Perusahaan",
        company_group_description_filter_txt:"Pencarian Berdasarkan Deskripsi Group Perusahaan",
        company_group_code_txt:"Kode Group Perusahaan",
        company_group_code_filter_txt:"Pencarian Berdasarkan Kode Group Perusahaan",
        companyGroupBillingTxt:"Group Perusahaan Billing",
        companyGroupTxt:"Group Perusahaan",
        news_portal_edit_txt:"Rubah Portal Berita",
        news_portal_detail_txt:"Detail Portal Berita",
        remove_txt:"Hapus",
        something_wrong:"ada sesuatu yang salah",
        drop_and_drop_file:"Seret dan lepas atau klik untuk mencari file",
        news_detail:"Detail Berita",
        deactive_txt:"Tidak Aktif",
        active_txt:"Aktif",
        brief:"Ringkasan",
        title:"Judul",
        news_to_date:"Tanggal Berita Selesai",
        news_from_date:"Tanggal Berita Mulai",
        news_portal_txt:"Portal Berita",
        news_portal_create_txt:"Buat Portal Berita",
        data_selected:"Data dipilih",
        branch_selected:"Branch Selected",
        pick_some_pool_name:"Pilih Beberapa Nama Pool",
        kunci_roda:"Kunci Roda",
        truck_selected:"Truck Selected",
        pick_some_type_truck:"Pilih Beberapa Jenis Truk",
        speedometer:"Speedometer",
        ban_serep:"Ban Serep",
        radio_tape:"Radio Tape",
        ban_stip:"Ban Stip",
        kotak_p3k:"Kotak P3K",
        spion_kiri:"Spion Kiri",
        spion_kanan:"Spion Kanan",
        dongkrak:"Dongkrak",
        equipment:"Peralatan",
        route:"Rute",
        customer:"Pelanggan",
        shipment_number:"Shipment Number",
        nomor:"No",
        in_to_pool:"In To Pool",
        exit_from_pool:"Exit From Pool",
        status_remarks:"Status Remarks",
        km_service:"KM Service",
        km_real:"KM Real",
        km_gps:"KM Gps",
        surveyor:"Surveyor",
        sim:"SIM",
        handphone:"Handphone",
        last_order:"Last Order",
        load_group:"Load Group",
        load_id:"Load ID",
        clear:"Hapus",
        ktp:"KTP",
        stnk:"STNK",
        muatan:"Muatan",
        km:"KM",
        needs:"Keperluan",
        transaction_date:"Tanggal Transaksi",
        no_txt:"Tidak",
        yes_txt:"Ya",
        pool_location:"Lokasi Pool",
        all:"Semua",
        from:"Dari",
        in_out_txt:"Masuk / Keluar",
        result_txt:"Hasil",
        sampai:"Sampai",
        period:"Periode",
        period_from:"Periode Dari",
        period_to:"Periode Sampai",
        truck_record_by_type:"Truck Record By Type",
        more_record:"More Records",
        truck_record_by_permit_status:"Truck Record By Permit Status",
        truck_record_by_permit:"Truck Record By Permit",
        permit_status:"Permit Status",
        time:"Waktu",
        date:"Tanggal",
        truck_type:"Tipe Truk",
        preventive_maintenance:"Preventive Maintenance",
        corrective_maintenance:"Corrective Maintenance",
        kir:"KIR",
        parking:"Parkir",
        branch_phone:"Telepon Cabang",
        branch_phone2:"Teelpon Ke 2 Cabang",
        branch_poscode:"Kodepos Cabang",
        download_file:"Download Berkas",
        file:"Berkas",
        keterangan:"Keterangan",
        jumlah_bruto:"Jumlah Bruto",
        pph_dipotong:"PPH Dipotong",
        tgl_bukti_potong:"Tgl Bukti Potong",
        no_bukti_potong:"No Bukti Potong",
        kode_objek_pajak:"Kode Objek Pajak",
        pasal:"Pasal",
        nama_dipotong:"Nama Dipotong",
        id_dipotong:"ID Dipotong",
        name_pemotong:"Nama Pemotong",
        id_pemotong:"ID Pemotong",
        audit_info:"Informasi Audit",
        pool_choose_txt:"Pilih Pool",
        user_choose_txt:"Pilih Pengguna",
        txtUserMappingCreate:"Buat Mapping Pengguna",
        txtUserMappingDetail:"Detail Mapping Pengguna",
        txtUserMapping:"Mapping Pengguna",
        pool_txt:"Pool",
        pool_address:"Alamat Pool",
        pool_latitude:"Latitude Pool",
        pool_longitude:"Longitude Pool",
        pool_postalcode:"Kodepos Pool",
        pool_city:"Kota Pool",
        pool_province:"Provinsi Pool",
        pool_name:"Nama Pool",
        branch_longitude:"Longitude Cabang",
        branch_latitude:"Latitude Cabang",
        branch_name_txt:"Nama Cabang",
        branch_province_txt:"Provinsi Cabang",
        branch_city_txt:"Kota Cabang",
        branch_region_txt:"Wilayah Cabang",
        branch_address_txt:"Alamat Cabang",
        pools_count_txt:"Jumlah Pool",
        OnTxt:"ON",
        OffTxt:"OFF",
        reject_description_txt:"Alasan Ditolak",
        type_reject_description_txt:"Ketik Alasan Ditolak",
        DashboardMonitoringTxt:"Dashboard Monitoring",
        TripAlertTxt:"Trip Alert",
        GateAlertTxt:"Gate Alert",
        DocAlertTxt:"Doc Alert",
        ServiceAlertTxt:"Service Alert",
        OntimeAnalysisTxt:"Ontime Analysis",
        reject_category_txt:"Kategory Penolakan",
        save_change_txt:"Simpan Perubahan",
        reason_category_txt:"Reason",
        reason_txt:"Penjelasan",
        edit_order_txt:"Rubah Pesanan",
        total_hours_txt:"Total Jam",
        reject_time_txt:"Waktu Penolakan",
        ct_operation_performance_txt:"Kinerja Operator CT",
        close_txt:"Tutup",
        lading_qty_txt:"Lading Qty",
        net_weight_txt:"Berat Bersih",
        weight_txt:"Berat",
        volume_txt:"Volume",
        lading_height_txt:"Lading Height",
        lading_width_txt:"Lading Width",
        lading_length_txt:"Lading Length",
        lading_type_txt:"Lading Type",
        package_type_txt:"Package Type",
        qty_txt:"Qty Charge",
        sku_description_txt:"Keterangan SKU",
        sku_txt:"SKU",
        detail_txt:"Detail",
        maps_txt:"Peta",
        destination_plan_txt:"Rencana Tujuan",
        destination_location_txt:"Lokasi Tujuan",
        destination_txt:"Tujuan",
        latitude_txt:"Latitude",
        longitude_txt:"Longitude",
        pickup_location_txt:"Lokasi Pengambilan",
        pickup_txt:"Pengambilan",
        shipwith_ref_txt:"Shipwith ref",
        remarks_txt:"Catatan",
        template_order_txt:"Template Order",
        status_tms_txt:"Status TMS",
        tms_id_txt:"TMS ID",
        load_id_txt:"Load ID",
        integration_description_txt:"Deskripsi Integrasi",
        integration_status_txt:"Status Integrasi",
        update_at_txt:"Perubahan Pada",
        update_by_txt:"Dirubah Oleh",
        create_at_txt:"Dibuat Pada",
        create_by_txt:"Dibuat Oleh",
        detail_transport_order_txt:"Detail Pesanan Transportasi",
        edit_transport_order_txt:"Rubah Pesanan Transportasi",
        audit_info_txt:"Informasi Audit",
        tracking_status_txt:"Riwayat Status",
        show_map_txt:"Tampilkan Peta",
        hide_map_txt:"Sembuyikan Peta",
        postpone_time_txt:"Waktu Tunda",
        postpone_order_txt:"Tunda Pesanan",
        reject_order_txt:"Tolak Pesanan",
        accept_order_txt:"Terima Pesanan",
        dest_plan_txt:"Rencana Tujuan",
        pickup_plan_txt:"Rencana Penjemputan",
        cubic_txt:"Kubikasi",
        tonnage_txt:"Tonase",
        transport_order_template_description_txt:"Order Template Name",
        submit_time_txt:'Waktu Di Kirimkan',
        action_txt:"Tindakan",
        dest_name_txt:"Nama Tujuan Pengiriman",
        pick_name_txt:"Nama Penjemputan",
        cancel_order_txt:"Batalkan Pesanan",
        draft_order_txt:"Draft Pesanan",
        send_order_txt:"Kirimkan Pesanan",
        order_status_txt:"Status Pesanan",
        order_date_txt:"Tanggal Pesanan",
        order_no_txt:"No Pesanan",
        orders_txt:"Pesanan",
        poMasterAdd:"Buat Purchase Order",
        asnMasterAdd:"Buat ASN",
        vendorMasterAdd:"Buat Perusahaan",
        vendorMasterEdit:"Edit Perusahaan",
        poMasterEdit:"Edit Purchase Order",
        transport_txt:"Transportasi",
        transport_orders_txt:"Pesanan Transportasi",
        day_30_truck_order_history_txt:"30 Hari Riwayat Pemesanan Tipe Truk",
        day_30_order_history_txt:"30 Hari Riwayat Pemesanan",
        no_data_available_txt:"Tidak Ada Data Yang Tersedia",
        year_truck_order_history_txt:"Riwayat Pesanan Tipe Truk 12 Bulan",
        day_truck_order_history_txt:"Riwayat Pemesanan Tipe Truk Berdasarkan Hari",
        year_order_history_txt:"Riwayat Pesanan 12 Bulan",
        day_order_history_txt:"Riwayat Pemesanan Berdasarkan Hari",
        check_internet_connection_txt:"Silahkan Periksa Internet KOneksi Anda",
        search_txt:"Cari",
        date_range_txt:"Rentang Tanggal",
        company_type_txt:"Tipe Company",
        user_type_txt:"Tipe User",
        user_type_filter_txt:"Pencarian Berdasarkan Tipe User",
        description_txt:"Penjelasan",
        coulmn_issue_txt:"Kolom Yang Bermasalah",
        customerEditTxt:"Ubah Customer",
        customerDetailTxt:"Detail Pelanggan",
        stateTxt:"Wilayah",
        customerAddTxt:"Tambah Data Pelanggan",
        location_reference_number_txt:"Nomor Referensi Lokasi",
        customerTxt:"Data Master Pelanggan",

        images_txt:"Gambar",

        typeDocumentTxt : "Tipe Dokumen",
        typeDocumentAccessAdd:"Tambah Tipe Dokumen",
        typeDocumentAccessEdit:"Ubah Tipe Dokumen",

        statusTxt : "Status",
        statusAccessAdd:"Tambah Status",
        statusAccessEdit:"Edit Status",
        
        txtPermissionRole:"Data Master Izin Role",
        txtPermissionRoleFilter:"Pencarian Berdasarkan Data Master Izin Role",
        txtPermission:"Data Master Izin",
        txtRoles:"Data Master Peran",
        txtMessages:"Pesan",
        txtSubject:"Subjek",
        pageContactUs:"Halaman Hubungi Kami",
        txtContactUs:"Hubungi Kami",
        MainTxt:"Utama",
        SupportTxt:"Bantuan",
        transactionData:"Transaksi",
        CreateTxt:"Tambah",
        ReadTxt:"Baca",
        UpdateTxt:"Ubah",
        DeleteTxt:"Hapus",
        UploadTxt:"Unggah Data",
        YesTxt:"Ya",
        NoTxt:"Tidak",
        skuAdd:"Tambah SKU",
        skuEdit:"ubah SKU",
        AdministrationTxt:"Administrasi",
        PermissionTxt:"Izin Akses",
        PermissionAdd:"Tambah Izin Akses",
        PermissionEdit:"Ubah Izin Akses",
        PermissionAddRole:"Tambah Izin Hak Akses",
        PermissionEditRole:"Ubah Izin Hak Akses",
        postalCodeAccessAdd:"Tambah Kode Pos",
        postalCodeAccessEdit:"Ubah Kode Pos",
        masterData:"Data Master",
        packageTxt:"Kemasan",
        packageCode:"Kode Kemasan",
        packageName:"Nama Kemasan",
        loadingTxt:"Memuat",
        submitFormTxt:"Kirimkan Data",
        submitOrderTxt:"Kirimkan Data Order",
        resetFormTxt:"Hapus Form",
        descriptionTxt : "Deskripsi",
        descriptionTxtFilter : "Pencarian Berdasarkan Deskripsi",
        roleNameTxt : "Nama Hak Akses",
        roleNameTxtFilter : "Pencarian Berdasarkan Nama Hak Akses",
        permissionNameTxt : "Nama Izin Akses",
        permissionNameFilterTxt:"Pencarian Berdasarkan Nama Izin Akses",
        ChangePasswordTxt:"Halaman Rubah Kata Sandi",
        changePassword:"Rubah Kata Sandi",
        profileTxt:"Halaman Profil Pengguna",
        dashboardTxt : "Selamat datang di Linc Middleware",
        dashboardMenu : "Beranda",
        autorizedErrorTxt : "Ups!! Halaman yang Anda minta tidak mendapatkan ijin",
        pageErrorTxt : "Ups!! Halaman yang Anda cari tidak ada",
        serverErrorTxt : "Ups!! Ada kesalahan. Silakan coba lagi nanti",
        companyAccessAdd:"Tambah Perusahaan",
        companyOmsAccessAdd:"Tambah Perusahaan OMS",
        companyFulfillmentOmsAccessAdd:"Add Company Fulfillment OMS",
        userOmsAccessAdd:"Add User OMS",
        userOmsAccessEdit:"Edit User OMS",
        fulfillmentOmsAccessAdd:"Tambah Warehouse OMS",
        companyAccessEdit:"Ubah Perusahaan",
        companyOmsAccessEdit:"Ubah Perusahaan OMS",
        companyFulfillmentOmsAccessEdit:"Edit Company Fulfillment OMS",
        fulfillmentOmsAccessEdit:"Ubah Gudang OMS",
        regionAccessAdd:"Tambah Wilayah",
        regionAccessEdit:"Ubah Wilayah",
        packageAccessAdd:"Tambah Kemasan",
        packageAccessEdit:"Ubah Kemasan",
        address:"Alamat",
        companyCodeTxt : "Kode Perusahaan",
        companyCodeFilterTxt:"Pencarian Berdasarkan Kode Perusahaan",
        companyTxt : "Perusahaan", 
        companyOmsTxt : "Perusahaan", 
        companyFulfillmentOmsTxt:"Gudang Perusahaan",
        fulfillmentOmsTxt : "Gudang", 
        regionTxt : "Wilayah",

        driverTxt : "Pengemudi",
        driverAccessAdd:"Tambah Pengemudi",
        driverAccessEdit:"Ubah Pengemudi",
        
        truckTxt : "Truck",
        truckAccessAdd:"Tambah Truck",
        truckAccessEdit:"Ubah Truck",

        documentTxt : "Dokumen",
        documentAccessAdd:"Tambah Dokumen",
        documentAccessEdit:"Ubah Dokumen",
        
        stopLocationTxt : "Lokasi Pemberhentian",
        stopLocationAccessAdd:"Tambah Lokasi Pemberhentian",
        stopLocationAccessEdit:"Ubah Lokasi Pemberhentian",

        branchTxt : "Cabang",
        branchAccessAdd:"Tambah Cabang",
        branchAccessEdit:"Ubah Cabang",
        branchAccessDetail:"Detail Cabang",
        branch_name:" Nama Cabang",
        branch_province:" Province Cabang",
        branch_city:" Kota Cabang",
        branch_region:" Wilayah Cabang",
        branch_address:"Alamat Cabang",

        ac_category: "Kategory AC",
        box_category: "Kategori Box",
        vehicle_no: "Nomor Kendaraan",
        carrier: "Carrier",
        device_id:"ID Perangkat",
        engine_number: "Nomor Mesin",
        gps_vendor: "GPS Vendor",
        km_limit: "Limit KM",
        manufacture_year: "Tahun Produksi",
        name_of_owner: "Nama Owner",
        ownership: " Ownership",
        project: "Project",
        purchased_year: "Tahun Pembelian",
        remark: "Catatan",
        truck_brand: "Truck Brand",
        truck_model: "Truck Model",
        truck_status: "Truck Status",
        type_truck: "Tipe Truk",
        unit_allocation: "Alokasi Unit",
        last_service:"Service Terakhir",
        last_km_service:"KM Service Terakhir",
        vin: "Vin",

        driver_id:"ID Pengemudi",
        driver_name:"Nama Pengemudi",
        branch_id:"Branch",
        site_name:" Nama Site",
        project_name:"Nama Project",
        driver_position:"Posisi Pengemudi",
        hp1:"HP 1",
        hp2:"HP 2",
        wa_hp1:"WA HP 1",
        sap_code:"SAP Code",
        sap_code_filter:"Pencarian Berdasarkan Kode SAP",
        driver_status:"Status Pengemudi",
        status_remark:"Status Remark",
        join_date:"Tgl Bergabung",
        nickname:"nama panggilan",
        brith_place:"Tempat lahir",
        brith_date:"Tanggal lahir",
        sim_type:"Type SIM",
        sim_expire_date:"Tanggal kadaluarsa SIM",
        ethnic:"Suku ",
        status_filter_txt:"Pencarian Berdasarkan Status",
        countryCodeTxt:"Kode Negara",
        countryTxt:"Negara",
        provinceTxt:"Provinsi",
        cityTxt:"Kota",
        cityTypeTxt:"Tipe Kota",
        districtTxt:"Desa",
        subDistrictTxt:"Tipe Desa",
        postalCodeTxt:"Kode Pos",
        commodityTxt:"Komoditas",
        locationTxt:"Lokasi",
        locationCodeTxt:"Kode Lokasi",
        locationNameTxt:"Nama Lokasi",
        locationAdd:"Tambah Lokasi",
        locationEdit:"Ubah Lokasi",
        locationContactName:"Nama Kontak",
        locationPhoneNumber:"No Telpon",
        systemCodeTxt:"Kode Sistem",
        skuCodeTxt:"SKU",
        skuDescriptionTxt:"SKU Deskripsi",
        skuLongDescriptionTxt:"SKU Deskripsi Panjang",
        companyCountry:"Negara",
        companyProvince:"Provinsi",
        companyCity:"Kota",
        companyArea:"Wilayah",
        companySubArea:"Sub Wilayah",
        companyVillage:"Desa",
        companyAddress:"Alamat",
        companyPostalCode:"Kode Pos",
        usernameTxt : "Nama Pengguna",
        username_filter_Txt:"Pencarian Berdasarkan Nama Pengguna",
        nameTxt : "Nama Lengkap",
        name_filter_Txt : "Filter By Nama",
        roleTxt : "Hak Akses",
        role_filter_Txt:"Pencarian Berdasarkan Hak Akses",
        emailAddress : "Alamat Surel",
        emailAddressFilter:"Pencarian Berdasarkan Alamat Surel",
        txtMyProfile:"Profil Pengguna",
        txtUserSetting:"Pengaturan Pengguna",
        txtUsers:"Pengguna",
        detail_user_oms:"Detail User OMS",
        txtLanguage:"Bahasa",
        txtSignOut:"Keluar",
        txtNotification:"Pemberitahuan",
        txtLogin:"Masuk",
        systemCodeAdd:"Tambah Kode Sistem",
        systemCodeEdit:"Ubah Kode Sistem",
        txtLogin2:"Silahkan masuk untuk melanjutkan",
        pageForgotPassword:"Halaman Lupa Kata Sandi",
        pageResetPassword:"Halaman Ulangi Sandi",
        fulfillmentCode:"Kode Gudang",
        companyCode:"Kode Perusahaan",
        companyCodeFilter:"Pencarian Berdasarkan Kode Perusahaan",
        companyName:"Nama Perusahaan",
        fulfillmentName:"Nama Gudang",
        companyCodeChoose:"Pilih Kode Perusahaan",
        regionCode:"Kode Wilayah",
        password:"Kata Sandi",
        newPassword:"Kata Sandi Baru",
        passwordConfirm:"Konfirmasi Kata Sandi",
        forgotPassword:"Lupa Kata Sandi",
        rememberPassword:"Ingat Kata Sandi",
        resetPassword:"Ulangi Password",
        captchaCode:"Kode Captcha",
        dashboard:"Beranda",
        areYouSure:"Apakah anda sudah yakin ?",
        yourData: "Data yang dikirim.",
        yourDataApprove: "Setuju data ini ",
        yourDataDelete: "Hapus data ini ",
        yourDataSend: "Apakah anda yakin ? mengirim data ini ",
        yourDataCancel: "Apakah anda yakin ? cancel data ini ",
        settings: "Pengaturan",
        wrongCaptchaCode:"Kode Captcha Salah",
        mainMenu:"Menu Utama",
        page404Desc:"kami tidak dapat menemukan halaman yang anda cari",
        page500Desc:"server kami sedang mengalami masalah, coba lah beberapa saat lagi.",
        goHOmeDesc:"Kehalaman Depan",
        userSettings:"Pengaturan Pengguna",
        name:"Nama",
        division:"Divisi",
        divisionCode:"Kode Divisi",
        divisionDesc:"Deskripsi Divisi",
        wrongPasswordConfirm:"Kata sandi konfirmasi tidak sama",
        userAccess:"Akses Pengguna",
        userAccessList:"Daftar Akses Pengguna",
        userAccessDetail:"Detail Akses Pengguna",
        userAccessEdit:"Rubah Akses Pengguna",
        backMess:"Kembali",
        editMess:"Ubah",
        deleteMess:"Hapus",
        submitMess:"Kirimkan",
        createNew:"Buat Data Baru",
        downloadData:"Unduh Data",
        uploadData:"Unggah Data",
        userAccessAdd:"Tambah Akses Pengguna Baru",
        roleAdd:"Tambah Hak Akses",
        roleEdit:"Ubah Hak Akses",
        commodityCodeTxt : "Kode Komoditas",
        sequenceTxt : "Urutan",
        valueTxt : "Nilai",
        commodityAdd:"Tambah Komoditas",
        commodityEdit:"Edit Komoditas",

        FakturPajakTxt:"Faktur Pajak",
        FakturPajakAdd: "Tambah Faktur Pajak",
        FakturPajakDetail: "Detail Faktur Pajak",
        FakturPajakEdit: "Edit Faktur Pajak",

        no_select_data: "Tidak ada baris terpilih  ",

    }
};
 

export default messages;
